import { __spreadArray, __extends, __assign, __awaiter, __generator } from 'tslib';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var lodash_merge = {exports: {}};

/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

(function (module, exports) {
/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeMax = Math.max,
    nativeNow = Date.now;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = merge;
}(lodash_merge, lodash_merge.exports));

var merge = lodash_merge.exports;

/**
 * TVF-modules @tencent/ovb-utils
 * v1.1.7
 * @author jimczjchen 2022-07-15 11:26:29
 */

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var e$1=function(){return (e$1=Object.assign||function(e){for(var t,n=1,i=arguments.length;n<i;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}).apply(this,arguments)},t$1=function(){function t(){}return t.setDefault=function(n){t.defaultOptions=e$1(e$1({},t.defaultOptions),n);},t.getCookie=function(e){var n=void 0,i=document.cookie?document.cookie.split("; "):[],r={};return i.some((function(i){var o=i.split("="),a=o[0],s=o.slice(1),u=t.decode(a),d=t.parseValue(s.join("="));return u===e?(n=d,!0):(r[u]=d,!1)})),void 0===e?r:n},t.setCookie=function(e,n,i){return void 0===i&&(i={}),t.set(e,n,i)},t.clearCookie=function(e,n,i){void 0===n&&(n=""),void 0===i&&(i=""),t.setCookie(e,"",{domain:n,path:i,expires:-1});},t.clearAllCookies=function(e,n){void 0===e&&(e=""),void 0===n&&(n="");var i=document.cookie?document.cookie.split("; "):[],r={domain:e,path:n,expires:-1};i.forEach((function(e){var n=e.split("=")[0];t.set(n,"",r,!0);}));},t.set=function(n,i,r,o){void 0===o&&(o=!1);var a=e$1(e$1({},t.defaultOptions),r),s=a.domain,u=a.path,d=a.secure,l=a.expires,c=a.sameSite,f=new Date(Date.now()+24*l*60*60*1e3),p=[(o?n:t.encode(n))+"="+t.stringifyValue(i),"; expires="+f.toUTCString(),u?"; path="+u:"",s?"; domain="+s:"",c?"; SameSite="+c:"",d?"; Secure":""].join("");return document.cookie=p,p},t.encode=function(e){return t.raw?e:encodeURIComponent(e)},t.decode=function(e){return t.raw?e:decodeURIComponent(e)},t.stringifyValue=function(e){return t.encode(t.json?JSON.stringify(e):String(e))},t.parseValue=function(e){if(t.raw)return e;var n=e;0===n.indexOf('"')&&(n=n.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return n=decodeURIComponent(n.replace(/\+/g," ")),t.json?JSON.parse(n):n}catch(e){}},t.raw=!1,t.json=!1,t.defaultOptions={domain:"",path:"/",expires:365,secure:!0,sameSite:""},t}(),n$2=function(e,t){var n=""+e;return !n||n.length>=t?n:""+Array(t+1-n.length).join("0")+e},i$2=/\[([^\]]+)]|(Y|y){1,4}|M{1,4}|D{1,2}|d{1,2}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g;function r$2(e,t){void 0===t&&(t="yyyy-MM-DD HH:mm:ss");var r=new Date(e);if(isNaN(r.getTime()))return r.toString();var o=t,a=""+r.getFullYear(),s=a.slice(-2),u=r.getHours(),d=""+(u%12||12),l=""+(r.getMonth()+1),c=""+r.getDate(),f=""+r.getDay(),p=""+r.getMinutes(),v=""+r.getSeconds(),g=""+r.getMilliseconds(),h=15*Math.round(r.getTimezoneOffset()/15),m=Math.abs(h),w=n$2(Math.floor(m/60),2),y=n$2(m%60,2),x=h<=0?"+":"-",b=""+x+w+":"+y,S=""+x+w+y,M={YY:s,YYYY:a,yy:s,yyyy:a,M:l,MM:n$2(l,2),D:c,DD:n$2(c,2),d:f,dd:n$2(c,2),H:""+u,HH:n$2(u,2),h:n$2(d,1),hh:n$2(d,2),a:u<12?"am":"pm",A:u<12?"AM":"PM",m:p,mm:n$2(p,2),s:v,ss:n$2(v,2),SSS:n$2(g,3),Z:b,ZZ:S};return o.replace(i$2,(function(e,t){return t||M[e]||e}))}var o$1;function v$1(e){try{return decodeURIComponent(e.replace(/\+/g," "))}catch(e){return null}}function g(e,t){var n=[null,void 0,"",NaN].includes(e);if(t.isSkipEmpty&&n)return null;var i=!t.isSkipEmpty&&n?"":e;try{return t.encode?encodeURIComponent(i):i}catch(e){return null}}function h$1(e){var t=e.split("#"),n=t[0],i=t[1],r=void 0===i?"":i,o=n.split("?"),a=o[0],s=o[1],u=void 0===s?"":s,d=v$1(r),l=Object.create(null);return u.split("&").forEach((function(e){var t=e.split("="),n=t[0],i=t[1],r=void 0===i?"":i,o=v$1(n),a=v$1(r);null===o||null===a||""===o&&""===a||l[o]||(l[o]=a);})),{url:a,query:l,hash:d}}function m(t,n){void 0===n&&(n={encode:!0,isSkipEmpty:!1});var i=t.url,r=t.query,o=void 0===r?{}:r,a=t.hash,s=i.split("#"),u=s[0],d=s[1],l=void 0===d?"":d,c=u.split("?")[0],f=[],p=g(a||l,n),v=e$1(e$1({},h$1(i).query),o);return Object.keys(v).forEach((function(e){var t=g(e,n),i=g(v[e],n);null!==t&&null!==i&&f.push(t+"="+i);})),c+(f.length?"?"+f.join("&"):"")+(p?"#"+p:"")}function y(e,t){var n;if(!t||!document.querySelectorAll("style[data-tag="+t+"]").length){var i=document.createElement("style");i.textContent=e.trim(),t&&(i.dataset.tag=t),null===(n=document.getElementsByTagName("head")[0])||void 0===n||n.appendChild(i);}}function x(t,n){return new Promise((function(i,r){if(n&&document.querySelectorAll("script[data-tag="+n+"]").length)return i();var o=document.createElement("script"),a=e$1({type:"text/javascript",charset:"utf-8"},t);Object.keys(a).forEach((function(e){return S(o,e,a[e])})),n&&(o.dataset.tag=n),o.onload=function(){return i()},o.onreadystatechange=function(){var e=o.readyState;["complete","loaded"].includes(e)&&(o.onreadystatechange=null,i());},o.onerror=r,document.body.appendChild(o);}))}function S(e,t,n){if(e)return void 0===n?e.getAttribute(t):e.setAttribute(t,n)}function M(e,t){return !!(null==e?void 0:e.className)&&-1!==e.getAttribute("class").split(" ").indexOf(t)}function q(e,t){if(e&&!M(e,t)){var n=(e.className+" "+t).trim();e.setAttribute("class",n);}}function _(e,t){if(e){var n=e.className.split(" "),i=n.indexOf(t);-1!==i&&(n.splice(i,1),e.className=n.join(" "));}}function E(e,t,n){if(e&&t)if("string"!=typeof t||void 0===n){if("string"==typeof t&&void 0===n)return (e.currentStyle?e.currentStyle:getComputedStyle(e,null))[t];"object"==typeof t&&Object.keys(t).forEach((function(n){return E(e,n,t[n])}));}else {var i=/width|height|left|right|top|bottom|padding|margin/i.test(t)&&"number"==typeof n;e.style[t]=i?n+"px":n;}}function O(e){E(e,{display:"none"});}function k(e,t){void 0===t&&(t="block"),E(e,{display:t});}function j(e,t){if(e)return void 0===t?e.innerText:void(e.innerText=t)}function C(e,t){if(e)return void 0===t?e.innerHTML:void(e.innerHTML=t)}!function(e){e[e.equal=0]="equal",e[e.low=-1]="low",e[e.high=1]="high";}(o$1||(o$1={}));var A=/^v?(?:\d+)(\.(?:[x*]|\d+)(\.(?:[x*]|\d+)(\.(?:[x*]|\d+))?(?:-[\da-z-]+(?:\.[\da-z-]+)*)?(?:\+[\da-z-]+(?:\.[\da-z-]+)*)?)?)?$/i;function P(e){var t,n,i=e.replace(/^v/,"").replace(/\+.*$/,""),r=(n="-",-1===(t=i).indexOf(n)?t.length:t.indexOf(n)),o=i.substring(0,r).split(".");return o.push(i.substring(r+1)),o}function N(e){return isNaN(Number(e))?e:Number(e)}function D(e){if("string"!=typeof e)throw new TypeError("Invalid argument expected string");if(!A.test(e))throw new Error("Invalid argument not valid semver ('"+e+"' received)")}function T(e,t){[e,t].forEach(D);for(var n=P(e),i=P(t),r=0;r<Math.max(n.length-1,i.length-1);r++){var a=parseInt(n[r]||"0",10),s=parseInt(i[r]||"0",10);if(a>s)return o$1.high;if(s>a)return o$1.low}var u=n[n.length-1],d=i[i.length-1];if(u&&d){var l=u.split(".").map(N),c=d.split(".").map(N);for(r=0;r<Math.max(l.length,c.length);r++){if(void 0===l[r]||"string"==typeof c[r]&&"number"==typeof l[r])return -1;if(void 0===c[r]||"string"==typeof l[r]&&"number"==typeof c[r])return 1;if(l[r]>c[r])return o$1.high;if(c[r]>l[r])return o$1.low}}else if(u||d)return u?o$1.low:o$1.high;return o$1.equal}var B=/</g,I=/>/g,H=/"/g,Q=/'/g,R=/&/g;function V(e){return e?(""+e).replace(R,"&amp;").replace(B,"&lt;").replace(I,"&gt;").replace(H,"&quot;").replace(Q,"&#39;"):""}

var commonTool = {
    /** lodash.merge */
    merge: merge,
    /** 检查是否支持es6语法 */
    supportES6: function () {
        try {
            // eslint-disable-next-line no-new-func
            new Function('var foo = (x)=>x+1');
        }
        catch (e) {
            return false;
        }
        return true;
    },
    isObject: function (list) {
        if (typeof list === 'object' && list.constructor === Object) {
            return true;
        }
        return false;
    },
    createGUID: function (lenParam) {
        if (lenParam === void 0) { lenParam = 32; }
        var len = lenParam || 32;
        var guid = '';
        for (var i = 1; i <= len; i++) {
            var n = Math.floor(Math.random() * 16.0).toString(16);
            guid += n;
        }
        return guid;
    },
    xss: V,
    /** 计算剔除discontinuity后的播放时间 */
    removeDiscontinuityTimeRangesFromPlayTime: function (time, discontinuities) {
        var inAdRange = commonTool.findDiscontinuityTimeRangeAtPlaytime(time, discontinuities);
        if (inAdRange)
            return inAdRange.start;
        var res = time;
        discontinuities.forEach(function (range) {
            if (range.end < time) {
                res -= (range.end - range.start);
            }
        });
        return res;
    },
    /** 找到当前播放时间所在的discontinuity区间 */
    findDiscontinuityTimeRangeAtPlaytime: function (time, discontinuities) {
        return commonTool.mergeTimeRanges(discontinuities).find(function (range) { return time >= range.start && time <= range.end; });
    },
    /** 合并多个连续的discontinuity区间 */
    mergeTimeRanges: function (ranges) {
        var curStart = -1;
        var lastEnd = -1;
        var mergedRanges = [];
        ranges.forEach(function (range) {
            var start = range.start, end = range.end;
            if (start <= lastEnd) {
                lastEnd = end;
                return;
            }
            lastEnd >= 0 && mergedRanges.push({
                start: curStart,
                end: lastEnd,
            });
            curStart = start;
            lastEnd = end;
        });
        if (curStart >= 0 && lastEnd >= 0)
            mergedRanges.push({ start: curStart, end: lastEnd });
        return mergedRanges;
    },
    /**
     * 对比版本号
     * @param  {String} nParam
     * @param  {String} kParam
     * @return {Number}   1:n>k, 0:n=k, -1:n<k
     */
    compareVersion: T,
    formatPlayTime: function (timeParam) {
        var time = timeParam;
        if (typeof time === 'string')
            time = parseInt(time, 10);
        if (typeof time !== 'number' || Number.isNaN(time))
            return '00:00';
        var formatZero = function (num) {
            if (num < 10)
                return "0".concat(num);
            return num;
        };
        var h = Math.floor(time / 3600);
        var m = Math.floor((time - (h * 3600)) / 60);
        var s = Math.floor(time - (h * 3600) - (m * 60));
        if (h === 0) {
            return [formatZero(m), formatZero(s)].join(':');
        }
        return [h, formatZero(m), formatZero(s)].join(':');
    },
    dateFormat: function (fmtParam, timeParam) {
        if (timeParam === void 0) { timeParam = Date.now(); }
        return r$2(timeParam, fmtParam || 'yyyy-MM-dd hh:mm:ss');
    },
    base64ToArrayBuffer: function (base64) {
        var binaryString = window.atob(base64);
        var len = binaryString.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
    },
    /**
     * 当前页面是否隐藏，如果不支持hidden属性，则返回-1
     * @return {0 | 1 | -1} 1:隐藏，0:显示，-1:不支持hidden属性
     */
    isPageHidden: function () {
        var hiddenTags = ['hidden', 'msHidden', 'webkitHidden'];
        var tag = hiddenTags.find(function (i) { return typeof document[i] !== 'undefined'; });
        if (tag) {
            return document[tag] ? 1 : 0;
        }
        return -1;
    },
    /**
     * 使用requestAnimationFrame实现倒计时功能（未实现取消倒计时，慎用）
     * @param callback 倒计时后的回调
     * @param time 倒计时长，单位毫秒
     */
    setTimeoutByRAF: function (callback, time) {
        var RAF = window.requestAnimationFrame || window.webkitRequestAnimationFrame;
        var startTime = +new Date();
        function loop() {
            if (+new Date() - startTime > time) {
                callback();
            }
            else {
                RAF(loop);
            }
        }
        loop();
    },
    /**
     * 将某个实例上指定的方法扩展到目标prototype上
     */
    assignApiToPrototype: function (fromInst, toPrototype, apis) {
        var instPrototype = Object.getPrototypeOf(fromInst);
        var existMembers = Object.getOwnPropertyNames(toPrototype);
        for (var i = 0, len = apis.length; i < len; i++) {
            var apiName = apis[i];
            var hasExisted = existMembers.indexOf(apiName) !== -1;
            if (hasExisted || typeof instPrototype[apiName] !== 'function') {
                continue;
            }
            toPrototype[apiName] = instPrototype[apiName].bind(fromInst);
        }
    },
};

var cookieTool = {
    /**
     * 设置一个cookie
     * @param name cookie名称
     * @param value cookie值
     * @param domain 所在域名 默认为window.location.host的值
     * @param path 所在路径 默认为是"\"
     * @param day 存活时间，单位:天
     */
    set: function (name, value, domain, path, day, raw) {
        var param = {
            domain: domain,
            path: path,
        };
        if (day) {
            param.expires = day;
        }
        // setCookie设计的api怪怪的，没法直接传raw去存原始字符串。所以这里只能设置这样raw绕开下默认encode
        var originRaw = t$1.raw;
        t$1.raw = raw;
        t$1.setCookie(name, value, param);
        t$1.raw = originRaw;
        return true;
    },
    /**
     * 获取指定名称的cookie值，如果不传名称，则返回记录所有cookie的key-value 对象
     * @param name cookie名称
     * @return 获取到的cookie值
     */
    get: function (name) {
        return t$1.getCookie(name) || '';
    },
    /**
     * 删除指定cookie,复写为过期
     * @param name cookie名称
     * @param domain 所在域 默认为 window.location.host的值
     * @param path 所在路径 默认为是"\"
     */
    del: t$1.clearCookie,
};
/**
 * cookie字符串解析成key-value对象
 */
function convertCookieStr2Object(cookieStr) {
    var cookies = cookieStr ? cookieStr.split('; ') : [];
    var cookieMap = {};
    cookies.forEach(function (cookie) {
        var _a = cookie.split('='), key = _a[0], value = _a.slice(1);
        cookieMap[key] = value.join('=');
    });
    return cookieMap;
}

/**
 * TVF-modules @tencent/ovb-event-emitter
 * v1.2.0
 * @author vfe 2022-11-15 16:56:32
 */

function t(t,e,n,r){return new(n||(n=Promise))((function(i,s){function o(t){try{c(r.next(t));}catch(t){s(t);}}function a(t){try{c(r.throw(t));}catch(t){s(t);}}function c(t){var e;t.done?i(t.value):(e=t.value,e instanceof n?e:new n((function(t){t(e);}))).then(o,a);}c((r=r.apply(t,e||[])).next());}))}function e(t,e){var n,r,i,s,o={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return s={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(s[Symbol.iterator]=function(){return this}),s;function a(s){return function(a){return function(s){if(n)throw new TypeError("Generator is already executing.");for(;o;)try{if(n=1,r&&(i=2&s[0]?r.return:s[0]?r.throw||((i=r.return)&&i.call(r),0):r.next)&&!(i=i.call(r,s[1])).done)return i;switch(r=0,i&&(s=[2&s[0],i.value]),s[0]){case 0:case 1:i=s;break;case 4:return o.label++,{value:s[1],done:!1};case 5:o.label++,r=s[1],s=[0];continue;case 7:s=o.ops.pop(),o.trys.pop();continue;default:if(!(i=o.trys,(i=i.length>0&&i[i.length-1])||6!==s[0]&&2!==s[0])){o=0;continue}if(3===s[0]&&(!i||s[1]>i[0]&&s[1]<i[3])){o.label=s[1];break}if(6===s[0]&&o.label<i[1]){o.label=i[1],i=s;break}if(i&&o.label<i[2]){o.label=i[2],o.ops.push(s);break}i[2]&&o.ops.pop(),o.trys.pop();continue}s=e.call(t,o);}catch(t){s=[6,t],r=0;}finally{n=i=0;}if(5&s[0])throw s[1];return {value:s[0]?s[1]:void 0,done:!0}}([s,a])}}}function n$1(t,e,n){if(n||2===arguments.length)for(var r,i=0,s=e.length;i<s;i++)!r&&i in e||(r||(r=Array.prototype.slice.call(e,0,i)),r[i]=e[i]);return t.concat(r||Array.prototype.slice.call(e))}var r$1;!function(t){t[t.sync=1]="sync",t[t.async=0]="async";}(r$1||(r$1={}));var i$1=function(){function t(){this._hasPriority=!1,this._array=[];}return t.prototype.insert=function(t,e){if(void 0===e&&(e=!1),0!==t.priority&&(this._hasPriority=!0),!this._hasPriority)return e?(this._array.unshift(t),0):(this._array.push(t),this._array.length-1);var n=this._array.findIndex((function(n){return n.priority===t.priority?e:n.priority<t.priority}));return -1===n?(this._array.push(t),this._array.length-1):(this._array.splice(n,0,t),n)},t.prototype.clone=function(){return n$1([],this._array,!0)},t.prototype.getListener=function(t){return this._array[t]},t.prototype.getListeners=function(){return this._array.map((function(t){return t.listener}))},t.prototype.remove=function(t){var e=this._array.findIndex((function(e){return e.listener===t}));-1!==e&&(this._array[e].isRemove=!0,this._array.splice(e,1));},t.prototype.findIdx=function(t){return this._array.findIndex((function(e){return e.listener===t}))},t.prototype.size=function(){return this._array.length},t}(),s$1=function(){function s(t){void 0===t&&(t={}),this._events=Object.create(null),this._cacheEvents=Object.create(null);var e=t.maxListeners,n=void 0===e?10:e,i=t.replayType,s=void 0===i?r$1.sync:i,o=t.isCache,a=void 0!==o&&o;this._isCache=a,this._replayType=s,this._maxListeners=n;}return s.prototype.setCacheStatus=function(t){this._isCache=t;},s.prototype.setReplayType=function(t){this._replayType=t;},s.prototype.getCacheStatus=function(){return this._isCache},s.prototype.clearCache=function(){this._isCache=!1,this._cacheEvents=Object.create(null);},s.prototype.setMaxListeners=function(t){return this._maxListeners=t,this},s.prototype.getMaxListeners=function(){return this._maxListeners},s.prototype.emit=function(t){for(var e=[],r=1;r<arguments.length;r++)e[r-1]=arguments[r];return this._emit.apply(this,n$1([!1,t],e,!1))},s.prototype.asyncEmit=function(t){for(var e=[],r=1;r<arguments.length;r++)e[r-1]=arguments[r];return this._emit.apply(this,n$1([!0,t],e,!1))},s.prototype.addListener=function(t,e){return this._addListener(t,{listener:e,priority:0,isOnce:!1})},s.prototype.on=function(t,e,n){return void 0===n&&(n=0),this._addListener(t,{listener:e,priority:n,isOnce:!1})},s.prototype.listeners=function(t){var e=this._events[t];return e?e.getListeners():[]},s.prototype.prependListener=function(t,e){return this._addListener(t,{listener:e,priority:0,isOnce:!1},!0)},s.prototype.once=function(t,e,n){return void 0===n&&(n=0),this._addListener(t,{listener:e,priority:n,isOnce:!0})},s.prototype.removeListener=function(t,e){var n=this._events[t];return n?(n.remove(e),this):this},s.prototype.off=function(t,e){return this.removeListener(t,e)},s.prototype.removeAllListeners=function(t){return void 0===t?(this._events=Object.create(null),this):(this._events[t]&&delete this._events[t],this)},s.prototype.listenerCount=function(t){var e;return (null===(e=this._events[t])||void 0===e?void 0:e.size())||0},s.prototype.eventNames=function(){return Object.getOwnPropertyNames(this._events)},s.prototype._emit=function(n,r){var i=this;void 0===n&&(n=!1);for(var o=[],a=2;a<arguments.length;a++)o[a-2]=arguments[a];var c=[{type:r,target:this,data:1===o.length?o[0]:o}],u=this._events[r],h={stopIndex:-1,onceCount:0,emitData:c};if(this._addCacheEvent(r,h,n),!u)return !!n&&Promise.resolve(!1);var p=Promise.resolve();return u.clone().some((function(r,o){return (r.isOnce||r.isRemove)&&(h.onceCount+=1),!r.isRemove&&(n?(p=p.then((function(){return t(i,void 0,void 0,(function(){return e(this,(function(t){switch(t.label){case 0:return h.stopIndex>=0||r.isRemove?[2]:(r.isOnce&&u.remove(r.listener),[4,r.listener.apply(this,c)]);case 1:return t.sent()===s.STOP_IMMEDIATE_PROPAGATION&&(h.stopIndex=Math.max(o-h.onceCount,0)),[2]}}))}))})),!1):(r.isOnce&&u.remove(r.listener),r.listener.apply(i,c)===s.STOP_IMMEDIATE_PROPAGATION&&(h.stopIndex=Math.max(o-h.onceCount,0),!0)))})),!n||p.then((function(){return !0}))},s.prototype._addCacheEvent=function(t,e,n){if(this._isCache){var r=n?Promise.resolve(e):e;this._cacheEvents[t]?this._cacheEvents[t].push(r):this._cacheEvents[t]=[r];}},s.prototype._replayCacheEvent=function(n,r,i,o){var a=this,c=o||this._cacheEvents[n];if(this._isCache&&c){var u=r.isOnce?1:0;c.some((function(o,h){return o instanceof Promise?(c[h]=o.then((function(o){return t(a,void 0,void 0,(function(){var t;return e(this,(function(e){switch(e.label){case 0:return o.stopIndex>=0&&i>o.stopIndex?[2,o]:[4,r.listener.apply(this,o.emitData)];case 1:return t=e.sent(),r.isOnce&&this.off(n,r.listener),t===s.STOP_IMMEDIATE_PROPAGATION?o.stopIndex=Math.max(i-u,0):o.stopIndex>=0&&i<=o.stopIndex&&(o.stopIndex=o.stopIndex-u+1),[2,o]}}))}))})),r.isOnce):(o.stopIndex>=0&&i>o.stopIndex||(r.isOnce&&a.off(n,r.listener),r.listener.apply(a,o.emitData)===s.STOP_IMMEDIATE_PROPAGATION?o.stopIndex=Math.max(i-u,0):o.stopIndex>=0&&i<=o.stopIndex&&(o.stopIndex=o.stopIndex-u+1)),r.isOnce)}));}},s.prototype._addListener=function(t,e,s){var o=this;void 0===s&&(s=!1),this._events[t]||(this._events[t]=new i$1);var a=this._events[t].insert(e,s);if(this._maxListeners>0&&this._events[t].size()===this._maxListeners&&console.warn("Possible EventEmitter memory leak detected. ".concat(this._events[t].size()," ").concat(String(t)," listeners ")+"added. Use emitter.setMaxListeners() to increase limit"),this._replayType===r$1.async){var c=this._cacheEvents[t]?n$1([],this._cacheEvents[t],!0):null;if(!c)return this;setTimeout((function(){var n=o._events[t].findIdx(e.listener);-1!==n&&o._replayCacheEvent(t,e,n,c);}));}else this._replayCacheEvent(t,e,a);return this},s.STOP_IMMEDIATE_PROPAGATION="EventEmitter.STOP_IMMEDIATE_PROPAGATION",s}();

/** url混淆工具使用的偏移量 */
var obfShift = new Date().getDay();
var urlTool = {
    /**
     * 将a-Z, 0-9之间的字符串按照指定偏移量进行移位，映射到另外一个同域的字符串
     */
    shiftAlphabet: function (str, shift) {
        if (!str || !shift)
            return str;
        return str.split('').map(function (char) {
            var charCode = char.charCodeAt(0);
            if (char >= 'a' && char <= 'z') {
                // Wrap around for lowercase letters
                charCode = ((((charCode - 97 + shift) % 26) + 26) % 26) + 97;
            }
            else if (char >= 'A' && char <= 'Z') {
                // Wrap around for uppercase letters
                charCode = ((((charCode - 65 + shift) % 26) + 26) % 26) + 65;
            }
            else if (char >= '0' && char <= '9') {
                // Wrap around for digits
                charCode = ((((charCode - 48 + shift) % 10) + 10) % 10) + 48;
            }
            return String.fromCharCode(charCode);
        })
            .join('');
    },
    /**
     * 将url中的path部分进行混淆，混淆后的url可以通过reverse参数还原
     */
    obfuscatePathComponent: function (url, reverse) {
        if (reverse === void 0) { reverse = false; }
        if (!url)
            return url;
        var urlObj = new URL(url);
        var pathArr = urlObj.pathname
            .split('/')
            .map(function (path) { return urlTool.shiftAlphabet(path, obfShift * (reverse ? -1 : 1)); });
        urlObj.pathname = pathArr.join('/');
        return urlObj.toString();
    },
    /**
     * 将对象转换成URL形式的字符串，可以指定combineParam间隔字符，默认为’&‘
     */
    object2string: function (obj, combine) {
        if (combine === void 0) { combine = '&'; }
        return this.convertUrlParam(obj, combine, false);
    },
    /**
     * 将对象转换成URL请求参数，默认使用&连接，并且会encode对象的key和value
     * @param obj 被转换对象
     * @param combine 连接符，默认为&
     * @param needEncodeURI 是否使用encodeURIComponent转换，默认为true
     * @returns 转换后的请求字符串
     */
    convertUrlParam: function (obj, combine, needEncodeURI) {
        if (combine === void 0) { combine = '&'; }
        if (needEncodeURI === void 0) { needEncodeURI = true; }
        if (!obj) {
            return '';
        }
        var objKeys = Object.keys(obj);
        if (objKeys.length <= 0) {
            return '';
        }
        var data = [];
        objKeys.forEach(function (i) {
            var keyValueStr = '';
            if (needEncodeURI) {
                keyValueStr = "".concat(encodeURIComponent(i), "=").concat(encodeURIComponent(obj[i]));
            }
            else {
                keyValueStr = "".concat(i, "=").concat(obj[i]);
            }
            data.push(keyValueStr);
        });
        return data.join(combine);
    },
    /**
     * 通过window.location.host获取当前页面根域名，如https://v.qq.com/test.html返回qq.com
     */
    getRootDomain: function () {
        var host = window.location.hostname || window.location.host;
        var sarray = window.location.host.split('.');
        if (sarray.length > 1) {
            host = sarray.slice(sarray.length - 2).join('.');
        }
        return host;
    },
    /**
     * 获取页面顶级地址（如果有iframe嵌套的情况）
     */
    getTopFrameUrl: function () {
        var topURL = '';
        if (window.top !== window) {
            try {
                topURL = window.top.location.href;
            }
            catch (e) {
                // 顶级域名不让你拿地址时候，会catch错误
                // DOMException: Blocked a frame with origin "http://v.qq.com" from accessing a cross-origin frame.
                topURL = document.referrer;
            }
        }
        else {
            topURL = window.location.href;
        }
        return topURL;
    },
    /**
     * 是否在iframe中运行
     */
    isInFrame: function () {
        var isIframe = false;
        try {
            isIframe = window.self !== window.top;
        }
        catch (e) {
            return true;
        }
        return isIframe;
    },
    /**
     * 返回传入URL的域名地址，如传入https://v.qq.com/test.html返回v.qq.com
     */
    getDomainOfURL: function (url) {
        if (typeof url === 'undefined' || url === null || url === '') {
            return '';
        }
        try {
            return new URL(url).hostname;
        }
        catch (_a) {
            return '';
        }
    },
    /**
     * 查找并返回指定URL里key的值，如果不存在返回空字符串
     */
    getUrlParamByKey: function (url, key) {
        return h$1(url || location.href).query[key] || '';
    },
    /**
     * 返回指定URL里所有参数
     */
    getUrlParams: function (url) {
        return h$1(url || location.href).query;
    },
    /**
     * 指定更新URL里的参数
     */
    updateUrlParam: function (url, key, val) {
        var u = url;
        var oldValue = this.getUrlParamByKey(u, key);
        var newStr = "".concat(key, "=").concat(val);
        if (!oldValue) {
            u = u + (u.indexOf('?') !== -1 ? '&' : '?') + newStr;
        }
        else {
            u = u.replace("".concat(key, "=").concat(oldValue), newStr);
        }
        return u;
    },
    /**
     * 获取当前URL的文件名，如https://v.qq.com/test.html返回test.html
     */
    getFileName: function (url) {
        if (!url) {
            return null;
        }
        var fileName = url;
        var idxWH = fileName.indexOf('?');
        if (idxWH > 0) {
            fileName = fileName.slice(0, idxWH);
        }
        var idxP = fileName.lastIndexOf('/');
        if (idxP > 0) {
            fileName = fileName.slice(idxP + 1, fileName.length);
        }
        var idxHash = fileName.lastIndexOf('#');
        if (idxHash > 0) {
            fileName = fileName.slice(0, idxHash);
        }
        return fileName;
    },
    /**
     * 获取网络url地址的文件名后缀
     */
    getFileExtension: function (url) {
        if (!url) {
            return null;
        }
        if (this.isWebRTCLink(url))
            return 'webrtc';
        var fileName = urlTool.getFileName(url);
        if (fileName) {
            var splitArr = fileName.split('.');
            if (splitArr && splitArr.length > 1) {
                return splitArr[splitArr.length - 1];
            }
        }
        return null;
    },
    isWebRTCLink: function (url) {
        return /^webrtc:\/\//.test(url);
    },
    removeSearchParams: function (url) {
        var idx = url.indexOf('?');
        if (idx > 0) {
            return url.slice(0, idx);
        }
        return url;
    },
};

var enableConsoleTime = urlTool.getUrlParamByKey(location.href, '__consoleTime') === '1';
/** 在没有创建播放器实例之前记录的一些执行步骤耗时信息，此时用一个假的播放器实例id */
var STEP_TIMER_FG_INST_ID = '-1';
var KernelStepKey;
(function (KernelStepKey) {
    /** 包含了从创建播放实例，到mse的sourceopen事件抛出 */
    KernelStepKey["ATTACH_MEDIA"] = "attachMedia";
    /** 加载、解析索引文件 */
    KernelStepKey["LOAD_MANIFAST"] = "loadManifest";
    /** 起播前的加载必要数据的耗时 */
    KernelStepKey["LOAD_CHUNK"] = "loadChunk";
    /** 起播前的转封装耗时 */
    KernelStepKey["TRANSMUX_CHUNK"] = "transmuxChunk";
    /** 起播前append到mse耗时 */
    KernelStepKey["APPEND_CHUNK"] = "appendChunk";
})(KernelStepKey || (KernelStepKey = {}));
/**
 * 执行步骤计时器
 */
var StepTimer = /** @class */ (function () {
    function StepTimer() {
    }
    StepTimer.clean = function (instanceId) {
        delete this.recordMap[instanceId];
    };
    StepTimer.push = function (key, start, end, instanceId) {
        if (instanceId === void 0) { instanceId = STEP_TIMER_FG_INST_ID; }
        var recordMap = this.getRecordMap(instanceId);
        var record = { start: start, end: end, cost: Math.round(end - start) };
        recordMap[key] = record;
        // console.log(`[step cost] ${key}=${record.cost}, r=[${record.start}-${record.end}]`);
    };
    /**
     * 启动一个计时器来跟踪某一个操作的占用时长
     */
    StepTimer.start = function (key, instanceId) {
        if (instanceId === void 0) { instanceId = STEP_TIMER_FG_INST_ID; }
        var recordMap = this.getRecordMap(instanceId);
        recordMap[key] = { start: performance.now(), end: 0, cost: 0 };
        // 为了在performance查看埋点
        if (enableConsoleTime) {
            console.time(key);
        }
    };
    StepTimer.end = function (key, instanceId) {
        if (instanceId === void 0) { instanceId = STEP_TIMER_FG_INST_ID; }
        var recordMap = this.recordMap[instanceId];
        if (!(recordMap === null || recordMap === void 0 ? void 0 : recordMap[key])) {
            return -1;
        }
        var record = recordMap[key];
        if (record.end === 0) {
            // 后面记录的不覆盖前面的（例如广告起播以后记录了一个耗时，那正片再起播时候就不会覆盖第一次记录）
            record.end = performance.now();
            record.cost = Math.round(record.end - record.start);
            // 为了在performance查看埋点
            if (enableConsoleTime) {
                console.timeEnd(key);
                // console.log(`[step cost] ${key}=${record.cost}, r=[${record.start}-${record.end}]`);
            }
        }
        return record.cost;
    };
    /**
     * 输出播放器实例对应的性能耗时数据
     * @param instanceId 播放器实例id，不传则输出全局数据（不属于某一个特定的播放器实例）
     * @returns
     */
    StepTimer.timing = function (instanceId) {
        var _this = this;
        if (instanceId === void 0) { instanceId = STEP_TIMER_FG_INST_ID; }
        var ret = {};
        if (this.recordMap[instanceId]) {
            Object.keys(this.recordMap[instanceId]).forEach(function (k) {
                var fk = k.replace(/-/g, '_'); // atta表不接受cp_vod-qa-reporter这种格式，换成cp_vod_qa_reporter
                ret[fk] = _this.recordMap[instanceId][k].cost;
            });
        }
        return ret;
    };
    StepTimer.getRecordMap = function (instanceId) {
        var recordMap = this.recordMap[instanceId];
        if (!recordMap) {
            recordMap = {};
            this.recordMap[instanceId] = recordMap;
        }
        return recordMap;
    };
    StepTimer.recordMap = {};
    return StepTimer;
}());

/**
 * 创建”函数调用日志装饰器“
 * @param scope 函数作用域名，传入成员函数所在的类名
 * @returns MethodDecorator
 */
function logMethodCallDecoratorCreator(scope) {
    if (scope === void 0) { scope = ''; }
    var methodDecorator = function (_target, name, desc) {
        var rawValue = desc.value;
        desc.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // 历史原因，类对象上的logger属性名不一样
            var logger = this._logger || this.logger;
            if (typeof (logger === null || logger === void 0 ? void 0 : logger.log) === 'function') {
                logger.log.apply(logger, __spreadArray(__spreadArray(["@".concat(scope, ".").concat(name, "(")], args, false), [')'], false));
            }
            return rawValue.apply(this, args);
        };
    };
    return methodDecorator;
}
var costTimeEmitter = new s$1();
/**
 * 创建“函数调用耗时装饰器”
 * @param scope 函数作用域名，传入成员函数所在的类名
 * @returns MethodDecorator
 */
function performanceCostDecoratorCreator(scope) {
    if (scope === void 0) { scope = ''; }
    var methodDecorator = function (_target, name, desc) {
        var rawValue = desc.value;
        desc.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var instanceId = guessInstanceId(this);
            if (!instanceId) {
                return rawValue.apply(this, args);
            }
            var startTime = performance.now();
            var result = rawValue.apply(this, args);
            var endTime = performance.now();
            costTimeEmitter.emit('done', { instanceId: instanceId, methodName: "".concat(scope, "::").concat(name), time: endTime - startTime });
            return result;
        };
    };
    return methodDecorator;
}
/**
 * 销毁保护装饰器。如果对象被销毁，调用此对象的方法将被拦截。
 */
function destroyProtectDecorator(_target, name, desc) {
    var rawValue = desc.value;
    desc.value = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var destroyed = this._destroyed || this.destroyed;
        if (!!destroyed) {
            return;
        }
        return rawValue.apply(this, args);
    };
}
function stepTimerClassDecorator(ctr) {
    Object.assign(ctr.prototype, {
        timeStart: function (key) {
            var instanceId = guessInstanceId(this);
            if (instanceId) {
                StepTimer.start(key, instanceId);
            }
        },
        timeEnd: function (key) {
            var instanceId = guessInstanceId(this);
            if (instanceId) {
                StepTimer.end(key, instanceId);
            }
        },
    });
}
function guessInstanceId(obj) {
    var _a;
    return ((_a = obj.config) === null || _a === void 0 ? void 0 : _a.instanceId) || obj.playerInstanceId || obj.instanceId;
}

var SimpleDefer = /** @class */ (function () {
    function SimpleDefer() {
        var _this = this;
        this.state = 'pending';
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = function (arg) {
                _this.state = 'fulfilled';
                resolve(arg);
            };
            _this.reject = function (arg) {
                _this.state = 'rejected';
                reject(arg);
            };
        });
    }
    return SimpleDefer;
}());
var TimeoutDefer = /** @class */ (function (_super) {
    __extends(TimeoutDefer, _super);
    function TimeoutDefer(config) {
        var _this = _super.call(this) || this;
        if (config.timeoutMS > 0) {
            setTimeout(function () { return _this.reject(); }, config.timeoutMS);
        }
        return _this;
    }
    return TimeoutDefer;
}(SimpleDefer));

var domTool = {
    insertStyle: y,
    loadScript: function (src, tag, timeoutMS, option) {
        var defer = new TimeoutDefer({ timeoutMS: timeoutMS });
        x(__assign(__assign({}, option), { src: src }), tag).then(defer.resolve)
            .catch(defer.reject);
        return defer.promise;
    },
    attr: S,
    removeAttr: function (el, attributeName) {
        if (!el)
            return;
        if (attributeName) {
            if (attributeName === 'src') {
                delete el.src;
            }
            else {
                el.removeAttribute(attributeName);
            }
        }
    },
    css: E,
    append: function (el, childNode) {
        if (!el)
            return;
        el.appendChild(childNode);
    },
    prepend: function (el, childNode) {
        if (el.children[0]) {
            el.insertBefore(childNode, el.children[0]);
        }
        else {
            el.appendChild(childNode);
        }
    },
    addClass: q,
    removeClass: _,
    hasClass: M,
    hide: O,
    show: k,
    text: j,
    html: C,
    /**
     * 从 HTML字符串创建 HTMLElement 对象
     * @param str HTML 字符串
     * @deprecated typo，请使用 createDom 方法
     */
    creatDom: function (str) {
        return this.createDom(str);
    },
    /**
     * 从 HTML字符串创建 HTMLElement 对象
     * @param domStr HTML 字符串
     */
    createDom: function (domStr) {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = domStr;
        return wrapper.firstChild;
    },
    getDomSize: function (el) {
        if (!el) {
            return { width: 0, height: 0 };
        }
        // currentStyle为ie属性
        var computedStyle = el.currentStyle ? el.currentStyle : window.getComputedStyle(el, null);
        var width = parseFloat(computedStyle.width);
        var height = parseFloat(computedStyle.height);
        return { width: width, height: height };
    },
    /**
     * 创建video标签，根据传入配置增加video标签属性等。
     */
    createVideoDom: function (options) {
        var _a = options || {}, _b = _a.attrOpts, attrOpts = _b === void 0 ? {} : _b, _c = _a.cssOpts, cssOpts = _c === void 0 ? {} : _c;
        var videoTag = document.createElement('video');
        // 设置video标签所有的attribute属性
        Object.keys(attrOpts).forEach(function (opt) {
            videoTag.setAttribute(opt, attrOpts[opt]);
        });
        // 设置video标签的style
        E(videoTag, cssOpts);
        return videoTag;
    },
    getElementFromConfig: function (value) {
        return typeof value === 'string' ? document.querySelector(value) : value;
    },
};

var masks = {};
function setMask(symbol, mask) {
    masks[symbol] = mask;
}
var Base64 = /** @class */ (function () {
    function Base64() {
    }
    Base64.fromUint8Array = function (buf, init) {
        if (init === void 0) { init = { urlSafe: false, padding: true }; }
        var _a = init.urlSafe, urlSafe = _a === void 0 ? false : _a, _b = init.padding, padding = _b === void 0 ? true : _b;
        var paddingChar = padding ? '=' : '';
        var base64Str = '';
        var bytes = new Uint8Array(buf);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            base64Str += String.fromCharCode(bytes[i]);
        }
        base64Str = btoa(base64Str)
            .replace(/=/g, paddingChar);
        return urlSafe
            ? base64Str.replace(/\+/g, '-').replace(/\//g, '_')
                .replace(/=/g, '')
            : base64Str;
    };
    Base64.toUint8Array = function (base64String, maskIdentifier) {
        // 先移除所有的padding
        var base64StringWithoutPadding = base64String.replace(/=/g, '');
        // 替换所有url-safe的字符
        var base64 = base64StringWithoutPadding
            .replace(/-/g, '+')
            .replace(/_/g, '/');
        var str = base64;
        if (maskIdentifier && masks[maskIdentifier]) {
            var mask_1 = masks[maskIdentifier].split('');
            var token = str.split('');
            str = token
                .map(function (char, index) { return String.fromCharCode(char.charCodeAt(0) ^ mask_1[index].charCodeAt(0)); })
                .join('');
        }
        // 这里注意，atob前需要再进行一次trim padding
        // 原因是mask可能会吞掉padding，导致保留了错误位数的padding
        var rawData = atob(str.replace(/=/g, ''));
        return new Uint8Array(rawData.length)
            .map(function (_, i) { return rawData.charCodeAt(i); });
    };
    Base64.fromUTF8 = function (str, init) {
        if (init === void 0) { init = { urlSafe: false, padding: true }; }
        return Base64.fromUint8Array(UTF8.toUint8Array(str), init);
    };
    Base64.toUTF8 = function (base64String) {
        return UTF8.fromUint8Array(Base64.toUint8Array(base64String));
    };
    return Base64;
}());
var Hex = /** @class */ (function () {
    function Hex() {
    }
    Hex.encode = function (str) {
        var hexTab = '0123456789abcdef';
        var output = '';
        for (var i = 0; i < str.length; i += 1) {
            var x = str.charCodeAt(i);
            output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
        }
        return output;
    };
    Hex.toUint8Array = function (hex) {
        var result = [];
        var str = hex;
        if (!str) {
            return result;
        }
        if (str.length % 2 !== 0) {
            return result;
        }
        while (str.length >= 2) {
            result.push(parseInt(str.substring(0, 2), 16));
            str = str.substring(2, str.length);
        }
        return new Uint8Array(result);
    };
    Hex.fromUint8Array = function (buf) {
        return Array.from(new Uint8Array(buf))
            .map(function (n) { return n.toString(16).padStart(2, '0'); })
            .join('');
    };
    return Hex;
}());
var UTF16 = /** @class */ (function () {
    function UTF16() {
    }
    UTF16.toUint16Array = function (string) {
        var array = new Uint16Array(string.length);
        for (var i = 0; i < string.length; i++) {
            array[i] = string.charCodeAt(i);
        }
        return array;
    };
    UTF16.fromUint16Array = function (buf) {
        return String.fromCharCode.apply(null, new Uint16Array(buf));
    };
    UTF16.fromTypeArray = function (array) {
        return String.fromCharCode.apply(null, new Uint16Array(array.buffer));
    };
    return UTF16;
}());
var UTF8 = /** @class */ (function () {
    function UTF8() {
    }
    UTF8.toUint8Array = function (str) {
        var utf8 = [];
        for (var i = 0; i < str.length; i += 1) {
            var charCode = str.charCodeAt(i);
            if (charCode < 0x80) { // 1-byte sequence
                utf8.push(charCode);
            }
            else if (charCode < 0x800) { // 2-byte sequence
                utf8.push(0xC0 | (charCode >> 6), 0x80 | (charCode & 0x3F));
            }
            else if (charCode < 0xD800 || charCode >= 0xE000) { // 3-byte sequence
                utf8.push(0xE0 | (charCode >> 12), 0x80 | ((charCode >> 6) & 0x3F), 0x80 | (charCode & 0x3F));
            }
            else { // 4-byte sequence (surrogate pair)
                i += 1;
                charCode = 0x10000 + (((charCode & 0x3FF) << 10) | (str.charCodeAt(i) & 0x3FF));
                utf8.push(0xF0 | (charCode >> 18), 0x80 | ((charCode >> 12) & 0x3F), 0x80 | ((charCode >> 6) & 0x3F), 0x80 | (charCode & 0x3F));
            }
        }
        return new Uint8Array(utf8);
    };
    UTF8.fromUint8Array = function (buf) {
        var bytes = new Uint8Array(buf);
        var len = bytes.byteLength;
        var result = '';
        var i = 0;
        while (i < len) {
            var firstByte = bytes[i++];
            if ((firstByte & 0x80) === 0) { // 1-byte sequence
                result += String.fromCharCode(firstByte);
            }
            else if ((firstByte & 0xE0) === 0xC0) { // 2-byte sequence
                result += String.fromCharCode(((firstByte & 0x1F) << 6) | (bytes[i++] & 0x3F));
            }
            else if ((firstByte & 0xF0) === 0xE0) { // 3-byte sequence
                result += String.fromCharCode(((firstByte & 0x0F) << 12)
                    | ((bytes[i++] & 0x3F) << 6)
                    | (bytes[i++] & 0x3F));
            }
            else { // 4-byte sequence
                var codePoint = ((firstByte & 0x07) << 18)
                    | ((bytes[i++] & 0x3F) << 12)
                    | ((bytes[i++] & 0x3F) << 6)
                    | (bytes[i++] & 0x3F);
                result += String.fromCharCode(
                // Extract the high surrogate:
                0xD800 | ((codePoint - 0x10000) >> 10), 
                // Extract the low surrogate:
                0xDC00 | ((codePoint - 0x10000) & 0x3FF));
            }
        }
        return result;
    };
    return UTF8;
}());
var encodingTool = {
    base64: Base64,
    utf8: UTF8,
    utf16: UTF16,
    hex: Hex,
    setMask: setMask,
};

/**
 * 获取绑定 / 解绑事件监听的 binder 函数，用于在一个函数中同时实现事件绑定和解绑的逻辑
 *```typescript
 *class MyPlugin {
 *   public constructor() {
 *     this.bindEvents(true);
 *   }
 *
 *   public destroy() {
 *     this.bindEvents(false);
 *   }
 *
 *   protected bindEvents(isBind: boolean) {
 *     const binder = getBinder(player, isBind);
 *     binder(MY_EVENT, this.onEventTrigger);
 *   }
 *}
 *```
 * @param emitter 继承于 EvtEmitter（player / plugin）的事件派发器
 * @param isBind 是否为绑定，true 返回 on，false 则返回 off 函数
 */
function getEventEmitterBinder(emitter, isBind) {
    return isBind ? emitter.on.bind(emitter) : emitter.off.bind(emitter);
}
/**
 * 获取绑定 / 解绑事件监听的 binder 函数，用于在一个函数中同时实现事件绑定和解绑的逻辑
 *```typescript
 *class MyPlugin {
 *   public constructor() {
 *     this.bindEvents(true);
 *   }
 *
 *   public destroy() {
 *     this.bindEvents(false);
 *   }
 *
 *   protected bindEvents(isBind: boolean) {
 *     const binder = getBinder(video as HTMLVideoElement, isBind);
 *     binder('pause', this.onVideoPause);
 *   }
 *}
 *```
 * @param emitter 继承于 EventTarget(HTMLElement）的事件派发器
 * @param isBind 是否为绑定，true 返回 addEventListener，false 则返回 removeEventListener 函数
 */
function getEventTargetBinder(emitter, isBind) {
    return isBind ? emitter.addEventListener.bind(emitter) : emitter.removeEventListener.bind(emitter);
}

/* eslint-disable operator-linebreak */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-multi-assign */
var EXTRA = [128, 32768, 8388608, -2147483648];
var HEX_CHARS = '0123456789abcdef'.split('');
var MD5 = /** @class */ (function () {
    function MD5() {
        var buffer = new ArrayBuffer(68);
        this.buffer8 = new Uint8Array(buffer);
        this.blocks = new Uint32Array(buffer);
        this.h0 = 0;
        this.h1 = 0;
        this.h2 = 0;
        this.h3 = 0;
        this.start = 0;
        this.bytes = 0;
        this.hBytes = 0;
        this.finalized = false;
        this.hashed = false;
        this.first = true;
    }
    MD5.prototype.update = function (message) {
        if (this.finalized) {
            return;
        }
        var code = 0;
        var index = 0;
        var i = 0;
        var length = message.length;
        var blocks = this.blocks;
        var buffer8 = this.buffer8;
        while (index < length) {
            if (this.hashed) {
                this.hashed = false;
                for (var s = 0; s <= 16; s += 1) {
                    blocks[s] = 0;
                }
            }
            for (i = this.start; index < length && i < 64; ++index) {
                code = message.charCodeAt(index);
                if (code < 0x80) {
                    buffer8[i++] = code;
                }
                else if (code < 0x800) {
                    buffer8[i++] = 0xc0 | (code >> 6);
                    buffer8[i++] = 0x80 | (code & 0x3f);
                }
                else if (code < 0xd800 || code >= 0xe000) {
                    buffer8[i++] = 0xe0 | (code >> 12);
                    buffer8[i++] = 0x80 | ((code >> 6) & 0x3f);
                    buffer8[i++] = 0x80 | (code & 0x3f);
                }
                else {
                    code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
                    buffer8[i++] = 0xf0 | (code >> 18);
                    buffer8[i++] = 0x80 | ((code >> 12) & 0x3f);
                    buffer8[i++] = 0x80 | ((code >> 6) & 0x3f);
                    buffer8[i++] = 0x80 | (code & 0x3f);
                }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
                this.start = i - 64;
                this.hash();
                this.hashed = true;
            }
            else {
                this.start = i;
            }
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    MD5.prototype.finalize = function () {
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        var blocks = this.blocks;
        var i = this.lastByteIndex;
        blocks[i >> 2] |= EXTRA[i & 3];
        if (i >= 56) {
            if (!this.hashed) {
                this.hash();
            }
            blocks[0] = blocks[16];
            blocks[16] = blocks[1] = blocks[2] = blocks[3] =
                blocks[4] = blocks[5] = blocks[6] = blocks[7] =
                    blocks[8] = blocks[9] = blocks[10] = blocks[11] =
                        blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = this.bytes << 3;
        blocks[15] = this.hBytes << 3 | this.bytes >>> 29;
        this.hash();
    };
    MD5.prototype.output = function () {
        this.finalize();
        var h0 = this.h0;
        var h1 = this.h1;
        var h2 = this.h2;
        var h3 = this.h3;
        return HEX_CHARS[(h0 >> 4) & 0x0F] + HEX_CHARS[h0 & 0x0F] +
            HEX_CHARS[(h0 >> 12) & 0x0F] + HEX_CHARS[(h0 >> 8) & 0x0F] +
            HEX_CHARS[(h0 >> 20) & 0x0F] + HEX_CHARS[(h0 >> 16) & 0x0F] +
            HEX_CHARS[(h0 >> 28) & 0x0F] + HEX_CHARS[(h0 >> 24) & 0x0F] +
            HEX_CHARS[(h1 >> 4) & 0x0F] + HEX_CHARS[h1 & 0x0F] +
            HEX_CHARS[(h1 >> 12) & 0x0F] + HEX_CHARS[(h1 >> 8) & 0x0F] +
            HEX_CHARS[(h1 >> 20) & 0x0F] + HEX_CHARS[(h1 >> 16) & 0x0F] +
            HEX_CHARS[(h1 >> 28) & 0x0F] + HEX_CHARS[(h1 >> 24) & 0x0F] +
            HEX_CHARS[(h2 >> 4) & 0x0F] + HEX_CHARS[h2 & 0x0F] +
            HEX_CHARS[(h2 >> 12) & 0x0F] + HEX_CHARS[(h2 >> 8) & 0x0F] +
            HEX_CHARS[(h2 >> 20) & 0x0F] + HEX_CHARS[(h2 >> 16) & 0x0F] +
            HEX_CHARS[(h2 >> 28) & 0x0F] + HEX_CHARS[(h2 >> 24) & 0x0F] +
            HEX_CHARS[(h3 >> 4) & 0x0F] + HEX_CHARS[h3 & 0x0F] +
            HEX_CHARS[(h3 >> 12) & 0x0F] + HEX_CHARS[(h3 >> 8) & 0x0F] +
            HEX_CHARS[(h3 >> 20) & 0x0F] + HEX_CHARS[(h3 >> 16) & 0x0F] +
            HEX_CHARS[(h3 >> 28) & 0x0F] + HEX_CHARS[(h3 >> 24) & 0x0F];
    };
    MD5.prototype.hash = function () {
        var a;
        var b;
        var c;
        var d;
        var bc;
        var da;
        var blocks = this.blocks;
        if (this.first) {
            a = blocks[0] - 680876937;
            a = (a << 7 | a >>> 25) - 271733879 << 0;
            d = (-1732584194 ^ a & 2004318071) + blocks[1] - 117830708;
            d = (d << 12 | d >>> 20) + a << 0;
            c = (-271733879 ^ (d & (a ^ -271733879))) + blocks[2] - 1126478375;
            c = (c << 17 | c >>> 15) + d << 0;
            b = (a ^ (c & (d ^ a))) + blocks[3] - 1316259209;
            b = (b << 22 | b >>> 10) + c << 0;
        }
        else {
            a = this.h0;
            b = this.h1;
            c = this.h2;
            d = this.h3;
            a += (d ^ (b & (c ^ d))) + blocks[0] - 680876936;
            a = (a << 7 | a >>> 25) + b << 0;
            d += (c ^ (a & (b ^ c))) + blocks[1] - 389564586;
            d = (d << 12 | d >>> 20) + a << 0;
            c += (b ^ (d & (a ^ b))) + blocks[2] + 606105819;
            c = (c << 17 | c >>> 15) + d << 0;
            b += (a ^ (c & (d ^ a))) + blocks[3] - 1044525330;
            b = (b << 22 | b >>> 10) + c << 0;
        }
        a += (d ^ (b & (c ^ d))) + blocks[4] - 176418897;
        a = (a << 7 | a >>> 25) + b << 0;
        d += (c ^ (a & (b ^ c))) + blocks[5] + 1200080426;
        d = (d << 12 | d >>> 20) + a << 0;
        c += (b ^ (d & (a ^ b))) + blocks[6] - 1473231341;
        c = (c << 17 | c >>> 15) + d << 0;
        b += (a ^ (c & (d ^ a))) + blocks[7] - 45705983;
        b = (b << 22 | b >>> 10) + c << 0;
        a += (d ^ (b & (c ^ d))) + blocks[8] + 1770035416;
        a = (a << 7 | a >>> 25) + b << 0;
        d += (c ^ (a & (b ^ c))) + blocks[9] - 1958414417;
        d = (d << 12 | d >>> 20) + a << 0;
        c += (b ^ (d & (a ^ b))) + blocks[10] - 42063;
        c = (c << 17 | c >>> 15) + d << 0;
        b += (a ^ (c & (d ^ a))) + blocks[11] - 1990404162;
        b = (b << 22 | b >>> 10) + c << 0;
        a += (d ^ (b & (c ^ d))) + blocks[12] + 1804603682;
        a = (a << 7 | a >>> 25) + b << 0;
        d += (c ^ (a & (b ^ c))) + blocks[13] - 40341101;
        d = (d << 12 | d >>> 20) + a << 0;
        c += (b ^ (d & (a ^ b))) + blocks[14] - 1502002290;
        c = (c << 17 | c >>> 15) + d << 0;
        b += (a ^ (c & (d ^ a))) + blocks[15] + 1236535329;
        b = (b << 22 | b >>> 10) + c << 0;
        a += (c ^ (d & (b ^ c))) + blocks[1] - 165796510;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ (c & (a ^ b))) + blocks[6] - 1069501632;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ (b & (d ^ a))) + blocks[11] + 643717713;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ (a & (c ^ d))) + blocks[0] - 373897302;
        b = (b << 20 | b >>> 12) + c << 0;
        a += (c ^ (d & (b ^ c))) + blocks[5] - 701558691;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ (c & (a ^ b))) + blocks[10] + 38016083;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ (b & (d ^ a))) + blocks[15] - 660478335;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ (a & (c ^ d))) + blocks[4] - 405537848;
        b = (b << 20 | b >>> 12) + c << 0;
        a += (c ^ (d & (b ^ c))) + blocks[9] + 568446438;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ (c & (a ^ b))) + blocks[14] - 1019803690;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ (b & (d ^ a))) + blocks[3] - 187363961;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ (a & (c ^ d))) + blocks[8] + 1163531501;
        b = (b << 20 | b >>> 12) + c << 0;
        a += (c ^ (d & (b ^ c))) + blocks[13] - 1444681467;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ (c & (a ^ b))) + blocks[2] - 51403784;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ (b & (d ^ a))) + blocks[7] + 1735328473;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ (a & (c ^ d))) + blocks[12] - 1926607734;
        b = (b << 20 | b >>> 12) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[5] - 378558;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[8] - 2022574463;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[11] + 1839030562;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[14] - 35309556;
        b = (b << 23 | b >>> 9) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[1] - 1530992060;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[4] + 1272893353;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[7] - 155497632;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[10] - 1094730640;
        b = (b << 23 | b >>> 9) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[13] + 681279174;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[0] - 358537222;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[3] - 722521979;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[6] + 76029189;
        b = (b << 23 | b >>> 9) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[9] - 640364487;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[12] - 421815835;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[15] + 530742520;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[2] - 995338651;
        b = (b << 23 | b >>> 9) + c << 0;
        a += (c ^ (b | ~d)) + blocks[0] - 198630844;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[7] + 1126891415;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[14] - 1416354905;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[5] - 57434055;
        b = (b << 21 | b >>> 11) + c << 0;
        a += (c ^ (b | ~d)) + blocks[12] + 1700485571;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[3] - 1894986606;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[10] - 1051523;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[1] - 2054922799;
        b = (b << 21 | b >>> 11) + c << 0;
        a += (c ^ (b | ~d)) + blocks[8] + 1873313359;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[15] - 30611744;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[6] - 1560198380;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[13] + 1309151649;
        b = (b << 21 | b >>> 11) + c << 0;
        a += (c ^ (b | ~d)) + blocks[4] - 145523070;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[11] - 1120210379;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[2] + 718787259;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[9] - 343485551;
        b = (b << 21 | b >>> 11) + c << 0;
        if (this.first) {
            this.h0 = a + 1732584193 << 0;
            this.h1 = b - 271733879 << 0;
            this.h2 = c - 1732584194 << 0;
            this.h3 = d + 271733878 << 0;
            this.first = false;
        }
        else {
            this.h0 = this.h0 + a << 0;
            this.h1 = this.h1 + b << 0;
            this.h2 = this.h2 + c << 0;
            this.h3 = this.h3 + d << 0;
        }
    };
    return MD5;
}());
var hashTool = {
    md5: function (message) { return new MD5().update(message)
        .output(); },
};

var jsonTool = {
    /** 封装try catch stringify */
    safelyStringify: function (obj, replacer, space) {
        try {
            return JSON.stringify(obj, replacer, space);
        }
        catch (e) {
            return '{}';
        }
    },
};

/**
 * @fileoverview 本地缓存工具
 */
var lsTool = {
    getData: function (name) {
        var data = '';
        try {
            if (window.localStorage) {
                data = window.localStorage[name];
            }
        }
        catch (e) {
            window.console.log(e);
        }
        return data;
    },
    setData: function (name, value) {
        if (name === 'undefined' || name === undefined) {
            return;
        }
        try {
            if (window.localStorage) {
                window.localStorage[name] = value;
            }
        }
        catch (e) {
            window.console.log(e);
        }
    },
    delData: function (name) {
        try {
            if (window.localStorage) {
                window.localStorage.removeItem(name);
            }
        }
        catch (e) {
            window.console.log(e);
        }
    },
};

/**
 * 页面上有模块加载器时，引入 CDN js 时，js 如果是 UMD / AMD / CJS 格式，则会注册到对应模块加载器上
 * 这个函数再将 CDN JS 实际的导出从模块加载器上引入回来
 *
 * @param moduleName 模块名，一般为打包工具 libraryName 配置，或者调用模块加载器注册时的名称
 * @param globalName UMD / IIFE 挂载到 window 对象上的名称，不传则使用 moduleName
 */
function requireModule(moduleName, globalName) {
    return __awaiter(this, void 0, void 0, function () {
        var context;
        var _a;
        return __generator(this, function (_b) {
            context = self;
            try {
                // Cjs 模块加载器
                if (typeof ((_a = context.module) === null || _a === void 0 ? void 0 : _a.export) === 'object') {
                    return [2 /*return*/, context.module.export[moduleName]];
                }
                // AMD 模块加载器
                if (typeof context.define === 'function' && context.define.amd && typeof context.require === 'function') {
                    return [2 /*return*/, new Promise(function (res) {
                            context.require([moduleName], function (moduleExport) {
                                res(moduleExport);
                            });
                        })];
                }
            }
            catch (_c) { }
            // IIFE Mode / 兜底
            return [2 /*return*/, context[globalName || moduleName]];
        });
    });
}
/**
 * 将某个属性挂载到 window 下，在挂载前检查 window 下是否有同名属性。
 * 当存在同名属性，或是挂载后属性被覆盖为其他对象时，触发回调
 * 比如下列 case
 * ```ts
 * const a = {};
 * mountGlobal({ globalName: 'A', target: a });
 * // 拦截，引用不一样
 * window.A = {};
 * // 放行，引用是一致的
 * window.A = a;
 * // 放行，有可能需要移除包的副作用
 * window.A = null;
 * window.A = undefined;
 * delete window.A;
 * ```
 * 具体所有 case 覆盖参考: https://git.woa.com/wizzeng/multi-player-detect
 */
function mountGlobal(options) {
    var globalName = options.globalName, target = options.target, onDuplicate = options.onDuplicate;
    // 如果模块已经被引入了，则不挂载，触发回调，不过如果引用一致则放行
    if (window[globalName] && window[globalName] !== target) {
        onDuplicate === null || onDuplicate === void 0 ? void 0 : onDuplicate(window[globalName]);
    }
    else {
        // 将 target 设置为 window 下的 getter / setter 模式，当 set 时，检查覆盖的行为是否符合预期
        // 这里一定需要使用 defineProperty 将属性设置为 getter / setter，防止先引入新版本，在引入老版本时，挂在 global 的属性被老版本上的逻辑覆盖
        Object.defineProperty(window, globalName, {
            configurable: true,
            enumerable: true,
            get: function () {
                return target;
            },
            set: function (val) {
                if (val && val !== target) {
                    // 如果为非空值，很可能为非预期的覆盖行为，触发回调
                    onDuplicate === null || onDuplicate === void 0 ? void 0 : onDuplicate(window[globalName]);
                }
                else {
                    // 赋空值视为合法
                    delete window[globalName];
                    window[globalName] = val;
                }
            },
        });
    }
}

/**
 * TVF-modules @tencent/ovb-request
 * v1.1.23
 * @author vfe 2023-04-25 17:07:39
 */
var r=function(){return (r=Object.assign||function(e){for(var t,r=1,n=arguments.length;r<n;r++)for(var o in t=arguments[r])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)};function n(e,t,r,n){return new(r||(r=Promise))((function(o,i){function c(e){try{a(n.next(e));}catch(e){i(e);}}function u(e){try{a(n.throw(e));}catch(e){i(e);}}function a(e){var t;e.done?o(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t);}))).then(c,u);}a((n=n.apply(e,t||[])).next());}))}function o(e,t){var r,n,o,i,c={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:u(0),throw:u(1),return:u(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function u(i){return function(u){return function(i){if(r)throw new TypeError("Generator is already executing.");for(;c;)try{if(r=1,n&&(o=2&i[0]?n.return:i[0]?n.throw||((o=n.return)&&o.call(n),0):n.next)&&!(o=o.call(n,i[1])).done)return o;switch(n=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return c.label++,{value:i[1],done:!1};case 5:c.label++,n=i[1],i=[0];continue;case 7:i=c.ops.pop(),c.trys.pop();continue;default:if(!(o=c.trys,(o=o.length>0&&o[o.length-1])||6!==i[0]&&2!==i[0])){c=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){c.label=i[1];break}if(6===i[0]&&c.label<o[1]){c.label=o[1],o=i;break}if(o&&c.label<o[2]){c.label=o[2],c.ops.push(i);break}o[2]&&c.ops.pop(),c.trys.pop();continue}i=t.call(e,c);}catch(e){i=[6,e],n=0;}finally{r=o=0;}if(5&i[0])throw i[1];return {value:i[0]?i[1]:void 0,done:!0}}([i,u])}}}var i=function(){function e(){this.interceptors=[];}return e.prototype.use=function(e,t){return this.interceptors.push({resolved:e,rejected:t}),this.interceptors.length-1},e.prototype.traverse=function(e,t){void 0===t&&(t=!1);var r=Promise.resolve(e);return (t?Array.prototype.reduceRight:Array.prototype.reduce).call(this.interceptors,(function(e,t){if(t){var n=t.resolved,o=t.rejected;r=r.then(n,o);}return e}),""),r},e.prototype.eject=function(e){this.interceptors[e]&&(this.interceptors[e]=null);},e}(),c={defaults:{timeout:0,method:"GET",mode:"cors",redirect:"follow",credentials:"same-origin"},headers:{common:{Accept:"application/json, text/plain, */*"},POST:{"Content-Type":"application/x-www-form-urlencoded"},PUT:{"Content-Type":"application/x-www-form-urlencoded"},PATCH:{"Content-Type":"application/x-www-form-urlencoded"}},baseURL:"",polyfillUrl:"https://vm.gtimg.cn/comps/script/fetch.min.js",interceptors:{request:new i,response:new i}},u=/^([a-z][a-z\d+\-.]*:)?\/\//i,a=Object.prototype.toString;function s(t){return n(this,void 0,void 0,(function(){var r;return o(this,(function(n){switch(n.label){case 0:if(window.fetch)return [2];n.label=1;case 1:return n.trys.push([1,3,,4]),[4,x({src:t})];case 2:return n.sent(),[3,4];case 3:throw r=n.sent(),new Error("加载 polyfill "+t+" 失败: "+r.message);case 4:return [2]}}))}))}function l(e){return ["Accept","Content-Type"].forEach((function(t){return r=t,void((n=e.headers)&&Object.keys(n).forEach((function(e){e!==r&&e.toUpperCase()===r.toUpperCase()&&(n[r]=n[e],delete n[e]);})));var r,n;})),function(e){if("[object Object]"!==a.call(e))return !1;var t=Object.getPrototypeOf(e);return null===t||t===Object.prototype}(e.body)&&(e.body=JSON.stringify(e.body),e.headers&&(e.headers["Content-Type"]="application/json;charset=utf-8")),e}var f=function(){},d=1;function h(e,n){return void 0===n&&(n={}),new Promise((function(o,i){var c,u=n.name,a=n.query,s=void 0===a?{}:a,l=n.param,p=void 0===l?"callback":l,h=n.timeout,v=void 0===h?6e4:h,m$1=n.prefix,y=void 0===m$1?"jsonp_":m$1,w=n.controller,b=n.charset,T=n.targetWindow,g=u||""+y+d++,E=T||window,j=document.createElement("script"),O=v?setTimeout((function(){x(!0),i(new Error("jsonp timeout"));}),v):null,x=function(e){var t;void 0===e&&(e=!1),null===(t=j.parentNode)||void 0===t||t.removeChild(j),O&&clearTimeout(O),w&&(w.element=null),E[g]=e?f:null;},C=m({url:e,query:r(r({},s),(c={},c[p]=g,c))});j.src=C,b&&(j.charset=b),w&&(w.element=j),j.onerror=function(e){x(),i(e);},E[g]=function(e){x(),o(e);},document.body.appendChild(j);}))}function v(e){return n(this,void 0,void 0,(function(){var n,i,a,p,f,d,h,v,m$1,y,w,b,T,g,E,j,O;return o(this,(function(o){switch(o.label){case 0:return n=c.baseURL,i=c.defaults,a=c.interceptors,[4,s(c.polyfillUrl)];case 1:return o.sent(),(p=r(r({},i),e)).headers||(p.headers=function(e){void 0===e&&(e="GET");var t=c.headers[e]||{};return r(r({},c.headers.common),t)}(p.method)),l(p),[4,a.request.traverse(p,!0)];case 2:if((f=o.sent())instanceof Error)throw f;return f.url=function(e,t){return !e||u.test(t)?t:e.replace(/\/+$/,"")+"/"+t.replace(/^\/+/,"")}(n,f.url),d=f.url,h=f.timeout,v=f.params,m$1=f.method,y=["GET","DELETE","OPTIONS","HEAD"].includes(void 0===m$1?"GET":m$1)&&!!v,w=y?m({url:d,query:v}):d,b=[],h&&!f.signal&&(E=new Promise((function(e){T=setTimeout((function(){e(new Error("timeout"));}),h);})),b.push(E),g=new AbortController,f.signal=g.signal),b.push(fetch(w,f).catch((function(e){return e}))),[4,Promise.race(b)];case 3:return j=o.sent(),T&&clearTimeout(T),[4,a.response.traverse(j)];case 4:if((O=o.sent())instanceof Error)throw null==g||g.abort(),O;return [2,O]}}))}))}

var targetWindow = window;
var netTool = {
    setJSONPTarget: function (win) {
        targetWindow = win;
    },
    jsonp: function (url, userOpts) {
        var opts = __assign({ targetWindow: targetWindow }, userOpts);
        return h(url, opts);
    },
    img: function (url) {
        return new window.Promise((function (resolve) {
            var img = new Image();
            img.src = url;
            resolve();
        }));
    },
    fetch: function (url, opts) {
        if (opts === void 0) { opts = {}; }
        return v({
            url: url,
            method: opts.method,
            body: opts.body,
        }).then(function (res) { return res.json(); });
    },
    /**
     * 发起xhr请求
     */
    xhr: function (opts) {
        var totalRetryCount = opts.retryCount || 0;
        var startTimestamp = +new Date();
        var currentRetryCount = 0;
        var impl = function (resolve, reject) {
            var retryHandler = function (error) {
                if (error === void 0) { error = 'xhrNetworkError'; }
                if (currentRetryCount < totalRetryCount) { // retry again
                    currentRetryCount++;
                    impl(resolve, reject);
                }
                else {
                    reject({ error: error, target: xhr });
                }
            };
            var xhr = new XMLHttpRequest();
            // 要先 open，否则 IE 下会抛出异常
            // @see https://stackoverflow.com/questions/28524485/xmlhttprequest-throwing-invalidsateerror-saying-object-state-must-be-opened
            xhr.open(opts.method || 'get', opts.url);
            if (opts.timeout) {
                xhr.timeout = opts.timeout;
            }
            if (opts.responseType) {
                xhr.responseType = opts.responseType;
            }
            xhr.withCredentials = !!opts.withCredentials;
            xhr.ontimeout = opts.ontimeout;
            if (opts.range) {
                xhr.setRequestHeader('Range', "bytes=".concat(opts.range[0], "-").concat(opts.range[1]));
            }
            if (opts.headers) {
                Object.keys(opts.headers).forEach(function (key) {
                    xhr.setRequestHeader(key, opts.headers[key]);
                });
            }
            xhr.onload = function () {
                if (xhr.status === 200 || xhr.status === 206) {
                    resolve({ data: xhr.response, target: xhr, startTimestamp: startTimestamp });
                    return;
                }
                retryHandler('xhrStatusCodeError');
            };
            xhr.onerror = function () {
                retryHandler();
            };
            xhr.onabort = function () {
                // to do
            };
            xhr.ontimeout = function () {
                retryHandler('xhrTimeoutError');
            };
            if (opts.body) { // post
                xhr.send(opts.body);
            }
            else {
                xhr.send();
            }
        };
        return new Promise((function (resolve, reject) {
            impl(resolve, reject);
        }));
    },
};

/**
 * ResizeObserver 的一个简单 polyfill，API 与原生相同
 * 使用 setInterval 轮询实现，默认轮询时长为 200ms
 *
 * !注意: 用于比对的是元素本身的 el.getBoundingClientRect() 返回值，某些情况下会和 native 触发时机略有区别
 * ! 此外，传入构造函数的回调函数中，第一个参数 ResizeObserverEntry 的数据会失真，需要自行从 DOM 中获取
 */
var ResizeObserverPolyfilled = /** @class */ (function () {
    function ResizeObserverPolyfilled(callback) {
        var _this = this;
        /** 存储 ResizeObserver.observe 传入的 Element 和 Options KV */
        this.targetOptionMap = new Map();
        /** 轮询定时器返回值 */
        this.pollTimer = null;
        /** 上次轮询，被 observe 元素的 DOMRect 属性，用于 diff 触发回调 */
        this.lastRectMap = new Map();
        /** 轮询时长，如果希望修改，可以在外部 as ResizeObserverPolyfilled 修改掉 */
        this.pollTimeout = DEFAULT_INTERVAL_TIMEOUT;
        /**
         * 定时器轮询回调函数
         * 轮询检查被监听元素的尺寸变更情况，在变更后触发 constructor 中传入的 callback
         */
        this.onPollTimeout = function () {
            var entries = [];
            // 如果某些元素，此次轮询已经从文档中移除，则从 map 中移除掉它
            _this.removeDisconnectedElements();
            // 遍历所有需要监听的元素，获取尺寸对比是否有变更
            _this.targetOptionMap.forEach(function (options, el) {
                var rectCurrent = el.getBoundingClientRect();
                var rectBefore = _this.lastRectMap.get(el);
                // 否则，将当前元素尺寸和上次存储的值进行 diff
                var isChange = _this.diffRect(rectBefore, rectCurrent, options === null || options === void 0 ? void 0 : options.box);
                // 如果有变更，则推入 entries 数组中
                if (isChange) {
                    entries.push(_this.assembleEntries(el, rectCurrent));
                }
                // 把本次获取到的元素尺寸存起来
                _this.lastRectMap.set(el, rectCurrent);
            });
            // 检查 entries 数组，如果有元素尺寸变更，触发回调函数
            if (entries.length) {
                _this.callback(entries, _this);
            }
        };
        this.callback = callback;
    }
    ResizeObserverPolyfilled.prototype.disconnect = function () {
        this.targetOptionMap.clear();
        this.setPoll(false);
    };
    ResizeObserverPolyfilled.prototype.observe = function (target, options) {
        this.targetOptionMap.set(target, options);
        this.setPoll(true);
    };
    ResizeObserverPolyfilled.prototype.unobserve = function (target) {
        this.targetOptionMap.delete(target);
    };
    /**
     * 取消上次轮询，重新开始轮询
     * @param isStart 是否开始轮询，false 为取消
     */
    ResizeObserverPolyfilled.prototype.setPoll = function (isStart) {
        if (isStart === void 0) { isStart = true; }
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
        if (isStart) {
            this.pollTimer = setInterval(this.onPollTimeout, this.pollTimeout);
        }
    };
    /**
     * 遍历存储变量，移除所有已经从 DOM 上移除的元素
     * 避免内存无法被正确释放
     */
    ResizeObserverPolyfilled.prototype.removeDisconnectedElements = function () {
        var _this = this;
        this.targetOptionMap.forEach(function (_, el) {
            if (!el.isConnected) {
                _this.targetOptionMap.delete(el);
                _this.lastRectMap.delete(el);
            }
        });
    };
    /**
     * 组装 callback 使用的 entries
     * Todo: 看目前使用情况没有用到 ResizeObserverEntry 的属性,这里计算起来复杂且耗时长，因此这里直接返回为空
     * @param target
     * @param rect
     * @returns
     */
    ResizeObserverPolyfilled.prototype.assembleEntries = function (target, rect) {
        return {
            target: target,
            borderBoxSize: [],
            contentBoxSize: [],
            contentRect: rect,
            devicePixelContentBoxSize: [],
        };
    };
    /**
     * 对比同一元素前后的 RectDOM 尺寸数据，根据 Options 规则判断元素是否变更
     * https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver/observe
     * @param rectBefore 之前的尺寸
     * @param rectAfter 之后的尺寸
     * @param boxOptions 对比规则
     * @returns 是否变更
     */
    ResizeObserverPolyfilled.prototype.diffRect = function (rectBefore, rectAfter, boxOptions) {
        if (boxOptions === void 0) { boxOptions = 'content-box'; }
        if (!rectBefore)
            return true;
        var diffAttrs = DIFF_ATTR_RULE_MAP[boxOptions];
        return diffAttrs.some(function (attr) { return rectBefore[attr] !== rectAfter[attr]; });
    };
    return ResizeObserverPolyfilled;
}());
/** 默认轮询时长 */
var DEFAULT_INTERVAL_TIMEOUT = 200;
var DIFF_ATTR_RULE_MAP = {
    'border-box': ['height', 'width', 'left', 'right', 'top', 'bottom'],
    'content-box': ['height', 'width'],
    'device-pixel-content-box': ['height', 'width'],
};
// 默认导出的是 native 实现，如果 window 未实现，则导出 polyfill
var ResizeObserver = window.ResizeObserver || ResizeObserverPolyfilled;

var stringTool = {
    /** @deprecated */
    arrayToString: encodingTool.utf16.fromUint16Array,
    /** @deprecated */
    base64ToUint8Array: encodingTool.base64.toUint8Array,
    /** @deprecated */
    arrayBufferToBase64: encodingTool.base64.fromUint8Array,
    /** @deprecated */
    stringToArray: encodingTool.utf16.toUint16Array,
};

/* eslint-disable no-useless-escape */
// 判断是否为移动端的正则
var mobileDevReg = /android|iPod|ipad|iPhone|mobile/i;
/**
 * copy自@tencent/useragent
 */
function uaMatch(ua) {
    var _a, _b, _c;
    if (typeof window !== 'object' && !ua) {
        // node端不传参数直接返回
        return this;
    }
    ua = ua || navigator.userAgent;
    ua = ua.toLowerCase();
    this.browser = {};
    this.os = {};
    this.mobile = false;
    this.spider = /(googlebot|bingbot|yandex|twitterbot|facebookexternalhit|rogerbot|linkedinbot|embedly|quora link preview|showyoubot|outbrain|pinterest\/0\.|pinterestbot|slackbot|vkShare|W3C_Validator|whatsapp|petalbot|applebot|mpcrawler|spider)/i.test(ua);
    this.headless = /headless/i.test(ua);
    if (mobileDevReg.test(ua))
        this.mobile = true;
    var osDetect = {
        android_1: /android[\s\/]([\d\.]+)/i,
        android_2: /android/i,
        android_3: /MIDP-/i,
        ipod_1: /iPod\stouch;\sCPU\siPhone\sos\s([\d_]+)/i,
        ipod_100: /iPod.*os\s?([\d_\.]+)/i,
        iphone: /iPhone;\sCPU\siPhone\sos\s([\d_]+)/i,
        iphone_100: /iPhone.*os\s?([\d_\.]+)/i,
        ipad_1: /ipad;\scpu\sos\s([\d_]+)/i,
        ipad_2: /ipad([\d]+)?/i,
        windows: /windows\snt\s([\d\.]+)/i,
        mac: /Macintosh.*mac\sos\sx\s([\d_\.]+)/i,
        linux: /Linux/i,
    };
    var osMatch;
    var osName;
    var osKeys = Object.keys(osDetect);
    for (var i = 0, len = osKeys.length; i < len; i++) {
        var osKey = osKeys[i];
        osMatch = osDetect[osKey].exec(ua);
        if (!osMatch)
            continue;
        osName = osKey.replace(/_\d+/, '');
        this.os[osName] = true;
        this.os.osName = osName;
        if (osMatch[1])
            this.os.version = osMatch[1].replace(/_/g, '.');
        break;
    }
    // $.os.ios
    if (this.os.iphone || this.os.ipad || this.os.ipod) {
        this.os.ios = true;
    }
    var browserDetect = {
        wechat: /MicroMessenger\/([\d\.]+)/i,
        ipadqq: /IPadQQ\/([\d\.]+)/i,
        mqq: /qq\/([\d\.]+)/i,
        qzone: /QZONEJSSDK\/([\d\.]+)/i,
        mqqbrowser: /mqqbrowser\/([\d\.]+)/i,
        qqbrowser: /[^m]QQBrowser\/([\d\.]+)/i,
        x5: /tbs\/(\d+)/i,
        xweb: /xweb\/(\d+)/i,
        uc: /UCBrowser\/([\d\.]+)/i,
        edg: /Edg\/([\d\.]+)/i,
        safari_1: /Version\/(([\d\.]+))\sSafari\/[\d\.]+/i,
        safari_2: /Safari\/([\d\.]+)/i,
        chrome_1: /CriOS\/([\d\.]+)/i,
        chrome_2: /Chrome\/([\d\.]+)/i,
        firefox: /Firefox\/([\d\.]+)/i,
        ie_1: /MSIE\s([\d\.]+)/i,
        ie_2: /(trident\/\d\.\d)/i,
        ie_3: /Edge\/(\d+\.\d+)/i,
        weibo: /weibo__([\d\.]+)/i,
        qqnews: /qqnews\/([\d\.]+)/i,
        qqlive_1: /QQLiveBrowser\/([\d\.]+)/i,
        qqlive_2: /QQLiveHDBrowser\/([\d\.]+)/i,
        kuaibao: /qnreading\/([\d\.]+)/i,
        liebao: /LieBaoFast\/([\d\.]+)/i,
        douban: /com\.douban\.frodo\/([\d\.]+)/i,
        miuibrowser: /MiuiBrowser/i,
        baidu: /baiduboxapp/i,
        browser360: /360browser/i,
        oppobrowser: /OppoBrowser/i,
        qqdownloader: /qqdownloader\/([\d\.]+)/i,
    };
    var browserMatch;
    var browserName;
    var bKeys = Object.keys(browserDetect);
    for (var j = 0, len = bKeys.length; j < len; j++) {
        var bkey = bKeys[j];
        browserMatch = browserDetect[bkey].exec(ua);
        if (!browserMatch)
            continue;
        browserName = bkey.replace(/_\d+/, '');
        if (this.browser[browserName])
            return this;
        this.browser[browserName] = {
            version: browserMatch[1],
        };
        // TODO: 下面两行的意思，就是匹配到的浏览器规则，随便选一个？
        this.browser.browserName = browserName;
        this.browser.version = browserMatch[1];
    }
    // There is no safari in android
    if (this.os.android && this.browser.safari) {
        this.browser.safari = null;
    }
    // chrome come first
    if (this.browser.chrome && this.browser.safari) {
        this.browser.safari = null;
    }
    // https://msdn.microsoft.com/library/ms537503.aspx#TriToken
    if (((_c = (_b = (_a = this.browser) === null || _a === void 0 ? void 0 : _a.ie) === null || _b === void 0 ? void 0 : _b.version) === null || _c === void 0 ? void 0 : _c.indexOf('trident')) > -1) {
        if (this.browser.ie.version.indexOf('6.0') > -1) {
            this.browser.ie.version = '10';
        }
        else if (this.browser.ie.version.indexOf('5.0') > -1) {
            this.browser.ie.version = '9';
        }
        else if (this.browser.ie.version.indexOf('4.0') > -1) {
            this.browser.ie.version = '8';
        }
        else {
            this.browser.ie.version = '11';
        }
    }
    return this;
}
/**
 * ua解析工具
 */
var uaTool = uaMatch.call({});

var LoopMode;
(function (LoopMode) {
    LoopMode[LoopMode["Timer"] = 0] = "Timer";
    LoopMode[LoopMode["RAF"] = 1] = "RAF";
})(LoopMode || (LoopMode = {}));
var TaskLoop = /** @class */ (function () {
    function TaskLoop(callback, mode) {
        var _a;
        this.running = false;
        this.loopRunnerPair = (_a = {},
            _a[LoopMode.RAF] = [window.requestAnimationFrame.bind(window), window.cancelAnimationFrame.bind(window)],
            _a[LoopMode.Timer] = [window.setTimeout.bind(window), window.clearTimeout.bind(window)],
            _a);
        this.callback = callback;
        if (mode === LoopMode.RAF && this.loopRunnerPair[mode][0]) {
            this.mode = LoopMode.RAF;
        }
        else {
            this.mode = LoopMode.Timer;
        }
        this.runner = this.loopRunnerPair[this.mode][0];
    }
    TaskLoop.prototype.start = function (interval) {
        var _this = this;
        if (interval === void 0) { interval = 0; }
        if (this.running)
            return;
        this.running = true;
        var loop = function () {
            var _a;
            if (!_this.running) {
                return;
            }
            (_a = _this.callback) === null || _a === void 0 ? void 0 : _a.call(_this);
            _this.loopId = _this.runner(loop, interval);
        };
        this.loopId = this.runner(loop, interval);
    };
    TaskLoop.prototype.stop = function () {
        if (!this.running)
            return;
        this.running = false;
        if (this.loopId)
            this.loopRunnerPair[this.mode][1](this.loopId);
        this.loopId = null;
    };
    TaskLoop.prototype.destroy = function () {
        this.stop();
        this.callback = null;
        this.loopId = null;
        this.loopRunnerPair = null;
    };
    return TaskLoop;
}());

/**
 * 根据传入的校验规则数组，依次调用，当某一条校验规则不满足时，停止校验并返回校验结果
 * @param validators 校验规则数组
 * @param validatorRunner 如何运行校验规则，并填充对应参数
 * @param runnerContext 运行校验规则时，this 指针指向
 */
function runValidators(validators, validatorRunner, runnerContext) {
    if (runnerContext === void 0) { runnerContext = null; }
    var validatorResult;
    // 1. 如果传入一个空的数组作为校验规则，直接通过
    if (!validators.length)
        return VALIDATE_PASS_RESULT;
    // 2. 遍历校验规则，调用校验函数
    validators.every(function (validator) {
        // 调用校验函数，如果函数没有返回校验结果，则认为校验失败
        validatorResult = validatorRunner.call(runnerContext, validator) || EMPTY_VALIDATE_RESULT;
        return validatorResult.isValid;
    });
    // 返回校验结果
    return validatorResult;
}
/** 默认校验通过返回结果 */
var VALIDATE_PASS_RESULT = {
    isValid: true,
    message: '',
};
var EMPTY_VALIDATE_RESULT = {
    isValid: false,
    message: 'Validator does not return anything.',
};

var wasmDetectionCache = null;
/**
 * 加密系统名称
 */
var KeySystems;
(function (KeySystems) {
    KeySystems["FairPlayWebKit"] = "com.apple.fps.1_0";
    KeySystems["Widevine"] = "com.widevine.alpha";
    KeySystems["WidevineHardware"] = "com.widevine.alpha.experiment";
    KeySystems["FairPlay"] = "com.apple.fps";
    KeySystems["Chacha"] = "com.tencent.chacha";
    KeySystems["PlayReady"] = "com.microsoft.playready";
    KeySystems["PlayReadyHardware"] = "com.microsoft.playready.hardware";
})(KeySystems || (KeySystems = {}));
/** HDR支持能力枚举 */
var HDRCapability;
(function (HDRCapability) {
    /** 不支持 */
    HDRCapability[HDRCapability["NOT_SUPPORTED"] = 0] = "NOT_SUPPORTED";
    /** 不支持HDR，但显示器支持广色域（display p3等），可以通过tone mapping降级到SDR播放 */
    HDRCapability[HDRCapability["WCG_DISPLAY_BUT_NO_HDR"] = 1] = "WCG_DISPLAY_BUT_NO_HDR";
    /** 支持HDR */
    HDRCapability[HDRCapability["SUPPORTED"] = 2] = "SUPPORTED";
})(HDRCapability || (HDRCapability = {}));
// 一些能力值缓存
var capabilitySessionCache = {};
// DRM 检测promise缓存，这里直接把key system缓存
var drmDetectionCache = {};
var gpuInfoCache = null;
function getSupportedKeySystemConfig(keySystem) {
    switch (keySystem) {
        case KeySystems.FairPlayWebKit:
            return null;
        case KeySystems.WidevineHardware:
            return {
                initDataTypes: ['cenc'],
                distinctiveIdentifier: 'required',
                persistentState: 'required',
                sessionTypes: ['temporary'],
                videoCapabilities: [{
                        robustness: 'HW_SECURE_ALL',
                        contentType: 'video/mp4; codecs="avc1.42E01E"',
                    }],
            };
        case KeySystems.Widevine:
            return {
                initDataTypes: ['cenc'],
                audioCapabilities: [{
                        contentType: 'audio/mp4; codecs="mp4a.40.2"',
                        robustness: 'SW_SECURE_CRYPTO',
                    }],
                videoCapabilities: [{
                        contentType: 'video/mp4; codecs="avc1.42E01E"',
                        robustness: 'SW_SECURE_CRYPTO',
                    }],
            };
        case KeySystems.FairPlay:
            return {
                initDataTypes: ['skd', 'cenc'],
                videoCapabilities: [
                    {
                        contentType: 'application/vnd.apple.mpegurl',
                        robustness: '',
                    },
                ],
            };
        case KeySystems.PlayReady:
        case KeySystems.PlayReadyHardware:
            return {
                initDataTypes: ['keyids', 'cenc'],
                audioCapabilities: [{
                        contentType: 'audio/mp4; codecs="mp4a.40.2"',
                    }],
                videoCapabilities: [{
                        contentType: 'video/mp4; codecs="avc1.42E01E"',
                    }],
            };
        default:
            return null;
    }
}
var videoTool = {
    getBuffered: function (video) {
        var buffered = [];
        var len = video.buffered.length;
        for (var i = 0; i < len; i++) {
            buffered.push({
                start: video.buffered.start(i),
                end: video.buffered.end(i),
            });
        }
        return buffered;
    },
    /**
     * 检查时间是否在video已经缓冲的buffer范围内
     * @param {number} time 相对于整个video标签的时间
     */
    checkTimeInBuffer: function (time, buffered) {
        var ret = false;
        var len = buffered.length;
        for (var i = 0; i < len; i++) {
            var sr = buffered[i].start;
            var er = buffered[i].end;
            if (time >= sr && time <= er) {
                ret = true;
                break;
            }
        }
        return ret;
    },
    clear: function (video) {
        if (!video) {
            return;
        }
        if (video instanceof HTMLVideoElement) {
            // 如果是真video标签，移除src属性。
            // 注意：video标签不能设置src=null再调用load，否则会产生一个类似http://xxx/null的请求。
            video.removeAttribute('src');
            // 如果像 webrtc 这样是通过设置 srcObject 来播放的源，则一并清除掉
            video.srcObject = null;
        }
        else {
            // 某些内核的video组件非HTMLVideoElement
            video.srcConfig = null;
            video.src = null;
        }
        video.load();
    },
    destroyElement: function (video) {
        var _a;
        if (!video) {
            return;
        }
        // 有扩展destroy接口的IVideoElement对象，调用一下destroy方法
        (_a = video.destroy) === null || _a === void 0 ? void 0 : _a.call(video);
        videoTool.clear(video);
        videoTool.removeElement(video, null);
    },
    /**
     * 使用 Canvas 进行视频截图，并返回截图信息
     */
    captureVideo: function (video, config) {
        var dx = config.dx, dy = config.dy, dw = config.dw, dh = config.dh;
        var videoWidth = video.videoWidth, videoHeight = video.videoHeight;
        var canvas = document.createElement('canvas');
        canvas.width = videoWidth;
        canvas.height = videoHeight;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, videoWidth, videoHeight);
        return {
            captureHeight: dh,
            captureWidth: dw,
            captureX: dx,
            captureY: dy,
            playtime: video.currentTime,
            data: ctx.getImageData(dx, dy, dw, dh),
        };
    },
    resizeElement: function (video, value) {
        var _a;
        if (!value || !video) {
            return;
        }
        if (video instanceof HTMLElement) {
            domTool.css(video, value);
        }
        else {
            var width = value.width, height = value.height;
            if (typeof width === 'number' && typeof height === 'number') {
                // 可能是模拟video标签的组件，例如electron内核使用的video标签
                (_a = video.resize) === null || _a === void 0 ? void 0 : _a.call(video, width, height);
            }
        }
    },
    appendElement: function (video, container) {
        var _a;
        if (video instanceof HTMLElement) {
            domTool.append(container, video);
        }
        else {
            // 可能是模拟video标签的组件，例如electron内核使用的video标签
            (_a = video.appendToParent) === null || _a === void 0 ? void 0 : _a.call(video, container);
        }
    },
    removeElement: function (video, container) {
        var _a;
        if (video instanceof HTMLElement) {
            if (video === null || video === void 0 ? void 0 : video.parentNode) {
                video.remove();
            }
        }
        else {
            // 可能是模拟video标签的组件，例如electron内核使用的video标签
            (_a = video.removeFromParent) === null || _a === void 0 ? void 0 : _a.call(video, container);
        }
    },
    /**
     * 设置video组件的object-fit属性类型
     * @param el video元素
     * @param type 填充类型
     */
    setElementFitType: function (el, type) {
        if (el && el instanceof HTMLElement) {
            domTool.css(el, { 'object-fit': type });
        }
    },
    /**
     * 缓冲数据的最大时长
     */
    getDefaultMaxBufferTime: function () {
        var connection = navigator.connection;
        if (connection && connection.type === 'wifi') {
            return 180;
        }
        if (connection && connection.type === '4g') {
            return 120;
        }
        return 180;
    },
    /**
     * 是否是自动播放被阻止的标识
     * @param errorMsg video标签play时catch到的异常信息
     */
    isAutoPlayBlockedMessage: function (errorMsg) {
        // 自动播放被阻止的信息name和message
        // chrome: NotAllowedError, play() failed because the user didn't interact with the document first.
        // safari/ios: NotAllowedError, The request is not allowed by the user agent or the platform in the current
        //             context, possibly because the user denied permission.
        // x5: NotAllowedError, play() can only be initiated by a user gesture.
        return errorMsg && /interact|not allowed|user gesture/.test(errorMsg);
    },
    /**
     * 是否支持两个或以上video标签同时播放视频。
     */
    supportSameTimePlay: function () {
        // x5的最新64位版本不支持多video同时播放
        if (uaTool.browser.x5 && ['45031', '45032'].indexOf("".concat(uaTool.browser.x5.version)) !== -1) {
            return false;
        }
        // 移动端qq浏览器
        if (uaTool.browser.mqqbrowser && !(uaTool.browser.qqlive || uaTool.browser.wechat || uaTool.browser.mqq)) {
            return false;
        }
        // ios9: 无法用js代码将视频静音（volume =0 或者muted），即使用物理键将手机静音，也无法两个视频同时播放
        // 包括ios11以下
        if (uaTool.os.ios && uaTool.os.version && commonTool.compareVersion(uaTool.os.version, '11.0') < 0) {
            return false;
        }
        return true;
    },
    /**
     * 目前发现低版本x5使用的webview(chrome57)无法检测到自动播放，即video.play()无法catch到被拦截的错误，
     * AudioContext也无法检测。
     */
    cannotDetectAutoPlayBlock: function () {
        return uaTool.browser.chrome && commonTool.compareVersion(uaTool.browser.chrome.version, '66.0') < 0;
    },
    /**
     * 支持#t标准的浏览器（支持指定起播点）
     */
    supportMediaFragmentsURISpec: function (enableMediaFragmentsURI) {
        if (typeof enableMediaFragmentsURI !== 'undefined') {
            return !!enableMediaFragmentsURI;
        }
        if (window.navigator.userAgent.indexOf('jsdom') !== -1) {
            // jsdom环境下不支持
            return false;
        }
        // 目前可以确定支持#t的：基本上桌面所有浏览器、移动端ios
        return !uaTool.mobile || !!uaTool.os.ios;
    },
    getVideoPlaybackQuality: function (video) {
        var totalVideoFrames = 0;
        var droppedVideoFrames = 0;
        if (video === null || video === void 0 ? void 0 : video.getVideoPlaybackQuality) {
            var info = video.getVideoPlaybackQuality();
            droppedVideoFrames = info.droppedVideoFrames || 0;
            totalVideoFrames = info.totalVideoFrames || 0;
        }
        else if (video && video.webkitDecodedFrameCount) {
            totalVideoFrames = video.webkitDecodedFrameCount;
            droppedVideoFrames = video.webkitDroppedFrameCount;
        }
        return { totalVideoFrames: totalVideoFrames, droppedVideoFrames: droppedVideoFrames };
    },
    /**
     * MSE能力检查
     */
    supportMSE: function () {
        if (capabilitySessionCache.mse !== undefined) {
            return capabilitySessionCache.mse;
        }
        var mediaSource = videoTool.getMediaSource();
        if (!mediaSource) {
            capabilitySessionCache.mse = false;
            return capabilitySessionCache.mse;
        }
        var sourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;
        var isTypeSupported = mediaSource
            && typeof mediaSource.isTypeSupported === 'function'
            && mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
        // if SourceBuffer is exposed ensure its API is valid
        // safari and old version of Chrome doe not expose SourceBuffer globally so checking SourceBuffer.prototype is
        // impossible
        var sourceBufferValidAPI = !sourceBuffer
            || (sourceBuffer.prototype
                && typeof sourceBuffer.prototype.appendBuffer === 'function'
                && typeof sourceBuffer.prototype.remove === 'function');
        capabilitySessionCache.mse = !!isTypeSupported && !!sourceBufferValidAPI;
        return capabilitySessionCache.mse;
    },
    /**
     * “粗略的”检查当前环境对主流视频格式的支持情况
     * <br>【注】返回结果只是可能支持，在视频开始播放以后仍然有可能抛出不支持媒体格式的异常。
     */
    supportVideoFormat: function () {
        var testVideoElement = document.createElement('video');
        //  mine类型参考：
        // https://developer.mozilla.org/zh-CN/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
        // https://www.iana.org/assignments/media-types/media-types.xhtml
        var mimetypesKind = {
            mp4: 'video/mp4',
            mov: 'video/mp4',
            hls: 'application/x-mpegURL',
            avi: 'video/x-msvideo',
            mpeg: 'video/mpeg',
            webm: 'video/webm',
            ogg: 'video/ogg',
        };
        var sptFormats = [];
        Object.keys(mimetypesKind).forEach(function (key) {
            var mimetype = mimetypesKind[key];
            var canPlayResult = testVideoElement.canPlayType(mimetype);
            // 'probably': 这种媒体文件似乎是可播放的。
            // 'maybe': 不能告诉你这种媒体文件是否能被播放，直到你尝试播放它。
            if (['maybe', 'probably'].indexOf(canPlayResult) !== -1) {
                sptFormats.push(key);
            }
        });
        return sptFormats;
    },
    /**
     * 判断当前环境是否支持av1编码的视频播放
     */
    supportAV1: function () {
        if (capabilitySessionCache.av1 !== undefined) {
            return capabilitySessionCache.av1;
        }
        capabilitySessionCache.av1 = videoTool.isMediaSourceTypeSupported('video/mp4;codecs=av01.0.12M.08');
        return capabilitySessionCache.av1;
    },
    /**
     * 判断当前环境是否支持hevc编码的视频播放
     */
    supportHevc: function () {
        if (capabilitySessionCache.hevc !== undefined) {
            return capabilitySessionCache.hevc;
        }
        capabilitySessionCache.hevc = videoTool.isMediaSourceTypeSupported('video/mp4;codecs="hvc1.1.6.L120.90"');
        return capabilitySessionCache.hevc;
    },
    /**
     * 判断环境是否支持 o266 播放
     */
    supportO266: function () {
        if (capabilitySessionCache.o266 === undefined) {
            // o266 目前只能用 wasm 内核在桌面端 Chrome 来播
            // 因此先检查 wasm 支持情况，并限定高性能机器（性能消耗过大）
            capabilitySessionCache.o266 = videoTool.isWasmKernelSupported()
                && navigator.hardwareConcurrency >= 8;
        }
        return capabilitySessionCache.o266;
    },
    /** 判断当前环境是否支持hevc profile main 10 */
    supportHEVCMain10: function () {
        if (capabilitySessionCache.hevcMain10 !== undefined) {
            return capabilitySessionCache.hevcMain10;
        }
        capabilitySessionCache.hevcMain10 = videoTool.isMediaSourceTypeSupported('video/mp4;codecs="hvc1.2.4.L120.90"');
        return capabilitySessionCache.hevcMain10;
    },
    /** 通过video canPlayType接口检测是否原生支持指定mime格式 */
    isVideoCanPlayType: function (mimeType) {
        var testVideoElement = document.createElement('video');
        return testVideoElement.canPlayType(mimeType);
    },
    /** 通过mse isTypeSupported接口检测是否支持指定mime格式 */
    isMediaSourceTypeSupported: function (mimeType) {
        var _a;
        try {
            return (_a = videoTool.getMediaSource()) === null || _a === void 0 ? void 0 : _a.isTypeSupported(mimeType);
        }
        catch (e) {
            return false;
        }
    },
    /**
     * 通过MediaCapabilities接口检测指定mime格式是否支持
     */
    isMediaCapabilitiesTypeSupported: function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var type, mimeType, _a, resolution, _b, bitrate, _c, framerate, mediaConfig, _d, height, width;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        type = config.type, mimeType = config.mimeType, _a = config.resolution, resolution = _a === void 0 ? '860x480' : _a, _b = config.bitrate, bitrate = _b === void 0 ? 800 : _b, _c = config.framerate, framerate = _c === void 0 ? 30 : _c;
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 3, , 4]);
                        mediaConfig = {
                            type: 'media-source',
                        };
                        switch (type) {
                            case 'audio':
                                mediaConfig.audio = {
                                    contentType: mimeType,
                                };
                                break;
                            case 'audio-spatial':
                                mediaConfig.audio = {
                                    contentType: mimeType,
                                    spatialRendering: true,
                                };
                                break;
                            case 'video': {
                                _d = resolution.toLowerCase().split('x'), height = _d[0], width = _d[1];
                                mediaConfig.video = {
                                    contentType: mimeType,
                                    bitrate: bitrate,
                                    framerate: framerate,
                                    height: +height,
                                    width: +width,
                                };
                            }
                        }
                        return [4 /*yield*/, navigator.mediaCapabilities.decodingInfo(mediaConfig)];
                    case 2: return [2 /*return*/, (_f.sent()).supported];
                    case 3:
                        _f.sent();
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    /**
     * 检测当前显示器是否支持HDR
     * @returns 0 不支持；1 不支持，但为广色域屏幕，可以通过系统级的tone map播放SDR内容；2 支持
     */
    isHDRSupported: function () {
        try {
            if (window.matchMedia('(dynamic-range: high)').matches)
                return HDRCapability.SUPPORTED;
            if (window.matchMedia('(color-gamut: p3)').matches)
                return HDRCapability.WCG_DISPLAY_BUT_NO_HDR;
            return HDRCapability.NOT_SUPPORTED;
        }
        catch (_a) {
            return HDRCapability.NOT_SUPPORTED;
        }
    },
    /**
     * 检测当前环境是否支持HEVC-based Dolby Vision格式
     */
    isDolbyVisionSupported: function () {
        if (capabilitySessionCache.dolbyVision !== undefined) {
            return capabilitySessionCache.dolbyVision;
        }
        capabilitySessionCache.dolbyVision = videoTool.isMediaSourceTypeSupported('video/mp4; codecs="dvhe"');
        return capabilitySessionCache.dolbyVision;
    },
    /**
     * 检测当前环境是否支持Dolby Atmos格式
     */
    isDolbyAtomsSupported: function () {
        if (capabilitySessionCache.dolbyAtoms !== undefined) {
            return capabilitySessionCache.dolbyAtoms;
        }
        capabilitySessionCache.dolbyAtoms = videoTool.isMediaSourceTypeSupported('audio/mp4; codecs="ec-3"');
        return capabilitySessionCache.dolbyAtoms;
    },
    getMediaSource: function () {
        if (typeof window !== 'undefined') {
            return window.MediaSource || window.WebKitMediaSource;
        }
    },
    /** 判断当前环境是否支持特定的EME配置 */
    isEncryptionSupported: function (keySystem, configuration) {
        return __awaiter(this, void 0, void 0, function () {
            var configurationToUse, hasEMESupport, hasCDMSupport, previousResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        configurationToUse = configuration || getSupportedKeySystemConfig(keySystem);
                        hasEMESupport = [window.MediaKeys, window.WebKitMediaKeys].some(function (i) { return i; });
                        if (!hasEMESupport)
                            return [2 /*return*/, false];
                        hasCDMSupport = typeof window.navigator.requestMediaKeySystemAccess !== 'undefined';
                        if (!hasCDMSupport)
                            return [2 /*return*/, false];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        previousResult = drmDetectionCache[keySystem];
                        if (!(previousResult !== undefined)) return [3 /*break*/, 3];
                        return [4 /*yield*/, drmDetectionCache[keySystem]];
                    case 2: return [2 /*return*/, !!(_a.sent())];
                    case 3:
                        drmDetectionCache[keySystem] = window.navigator.requestMediaKeySystemAccess(keySystem, [configurationToUse]);
                        return [4 /*yield*/, drmDetectionCache[keySystem]];
                    case 4: return [2 /*return*/, !!(_a.sent())];
                    case 5:
                        _a.sent();
                        return [2 /*return*/, false];
                    case 6: return [2 /*return*/];
                }
            });
        });
    },
    /**
     * @deprecated 维持兼容性，推荐使用isEncryptionSupported
     * 判断当前环境是否支持widevine
     */
    supportWidevine: function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, videoTool.isEncryptionSupported(KeySystems.Widevine)];
            });
        });
    },
    /** 判断当前环境是否支持fairplay */
    supportFairplay: function () {
        var keySystem = KeySystems.FairPlayWebKit;
        if (!window.WebKitMediaKeys)
            return false;
        var isTypeSupported = window.WebKitMediaKeys.isTypeSupported(keySystem, 'video/mp4');
        return isTypeSupported;
    },
    supportWebGL: function () {
        if (capabilitySessionCache.webgl !== undefined) {
            return capabilitySessionCache.webgl;
        }
        var canvasElement = document.createElement('canvas');
        var webglContext;
        try {
            webglContext = canvasElement.getContext('webgl');
        }
        catch (e) {
            capabilitySessionCache.webgl = false;
            return false;
        }
        capabilitySessionCache.webgl = !!webglContext;
        return capabilitySessionCache.webgl;
    },
    /**
     * 判断当前环境是否支持WebRTC
     */
    isWebRTCSupported: function () {
        var isIOS = Boolean(uaTool.os.ios);
        var isUC = Boolean(uaTool.browser.uc);
        var isSafari = Boolean(uaTool.browser.safari);
        // android的uc浏览器直接就不支持webrtc，ios的uc浏览器会劫持video标签，导致无法播放视频流
        if (isUC) {
            return false;
        }
        // isIOS的safari 11.1.2以上才支持WebRTC
        if (isIOS && isSafari && commonTool.compareVersion(uaTool.os.version, '11.1.2') < 0) {
            return false;
        }
        // 检查 window 下是否支持对应 API
        return 'RTCPeerConnection' in window || 'webkitRTCPeerConnection' in window;
    },
    isPositionBuffered: function (video, position) {
        var buffered = video.buffered;
        var time = position || video.currentTime;
        for (var i = 0; i < buffered.length; i++) {
            if (time >= buffered.start(i) && time <= buffered.end(i)) {
                return true;
            }
        }
        return false;
    },
    getNextBufferedStart: function (video, position) {
        var buffered = video.buffered;
        var time = position || video.currentTime;
        for (var i = 0; i < buffered.length; i++) {
            if (buffered.start(i) > time) {
                return buffered.start(i);
            }
        }
        return -1;
    },
    getLastBufferedEnd: function (video, position) {
        var buffered = video.buffered;
        var time = position || video.currentTime;
        for (var i = buffered.length - 1; i >= 0; i--) {
            if (buffered.end(i) < time) {
                return buffered.end(i);
            }
        }
        return -1;
    },
    /**
     * 通过webgl检测当前环境是否开启了硬件加速
     */
    isHardwareAccelerated: function () {
        if (capabilitySessionCache.hardwareAccelerated !== undefined) {
            return capabilitySessionCache.hardwareAccelerated;
        }
        try {
            var canvas = document.createElement('canvas');
            var attributes = {
                alpha: true,
                antialias: false,
                depth: true,
                failIfMajorPerformanceCaveat: true,
                stencil: true,
            };
            capabilitySessionCache.hardwareAccelerated = !!(canvas.getContext('webgl', attributes)
                || canvas.getContext('experimental-webgl', attributes));
            return capabilitySessionCache.hardwareAccelerated;
        }
        catch (_a) {
            capabilitySessionCache.hardwareAccelerated = false;
            return false;
        }
    },
    /**
     * 获取设备的GPU信息
     *
     * @returns {({ vendor: string; renderer: string } | null)}
     */
    collectGPUInfo: function () {
        if (gpuInfoCache)
            return gpuInfoCache;
        try {
            var canvas = document.createElement('canvas');
            var gl = canvas.getContext('webgl');
            var debugInfo = gl === null || gl === void 0 ? void 0 : gl.getExtension('WEBGL_debug_renderer_info');
            if (!debugInfo)
                return null;
            gpuInfoCache = {
                renderer: (gl === null || gl === void 0 ? void 0 : gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)) || '',
                vendor: (gl === null || gl === void 0 ? void 0 : gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL)) || '',
            };
            return gpuInfoCache;
        }
        catch (_a) {
            return null;
        }
    },
    /**
     * 尝试通过初始化一个空的 wasm 文件，来判断当前环境是否支持 wasm
     */
    isWasmSupported: function () {
        // 如果已经探测过了，返回一个 cache 值
        if (wasmDetectionCache !== null) {
            return wasmDetectionCache;
        }
        // 如果 window 上连 api 都没有，返回 false
        if (!window.WebAssembly) {
            wasmDetectionCache = false;
            return false;
        }
        try {
            // 一个空的 WASM 二进制的 int8 表示
            // 里面只有一个 (module)
            var wasmAbf = Uint8Array.from([0, 97, 115, 109, 1, 0, 0, 0]);
            var wasmModule = new WebAssembly.Module(wasmAbf);
            var wasmInstance = new WebAssembly.Instance(wasmModule);
            // 看看能不能创建成功
            wasmDetectionCache = wasmInstance instanceof WebAssembly.Instance;
        }
        catch (_a) {
            // 如果有异常，则没办法实例化 WASM，则判断不支持
            wasmDetectionCache = false;
        }
        finally {
            return wasmDetectionCache;
        }
    },
    /**
     * 判断是否支持 FIXED SIMD
     * @see https://github.com/GoogleChromeLabs/wasm-feature-detect/blob/main/src/detectors/simd/module.wat
     */
    isSimdSupported: function () {
        // 一个带有 simd 指令的 wasm binary 文件二进制值
        var wasmBin = new Uint8Array([
            0, 97, 115, 109, 1, 0, 0, 0, 1, 5, 1, 96, 0, 1, 123, 3, 2, 1, 0, 10, 10, 1, 8, 0, 65, 0, 253, 15, 253, 98, 11,
        ]);
        try {
            return WebAssembly.validate(wasmBin);
        }
        catch (_a) {
            return false;
        }
    },
    /**
     * 是否支持 Chrome trials token 下发 SharedArrayBuffer
     * WASM 内核需要 SAB 来实现 pthread，而 SAB 是通过 Chrome trials 下发的，只能在 Chromium 内核中获取到
     */
    isSupportSABTrails: function () {
        // 1. 移动端是不支持的
        return !uaTool.mobile
            // 2. Https 协议才能使用
            && location.protocol === 'https:'
            // 3. Chrome 和 Chromium edge 才支持 Chrome Trails 下发 SAB
            && Boolean((uaTool.browser.chrome && !uaTool.browser.ie) // 2.1 这里判断确定是 Chrome 而不是 IE
                || uaTool.browser.edg); // 2.2 判断是 Chromium Edge
    },
    /**
     * 判断当前环境是否支持WASM播放
     */
    isWasmKernelSupported: function () {
        return this.isSupportSABTrails() // WASM 内核需要 SAB 来支持 pthread
            && this.isWasmSupported()
            && this.isSimdSupported() // WASM 内核已经带有 SIMD 指令（o266)，因此必须要支持 SIMD 才可以正常初始化
            && !!window.customElements
            && commonTool.supportES6() // wasm内核还需要支持webcomponent、因此也是es6语法
            && videoTool.supportWebGL();
    },
    /**
     * 是否支持流式的fetch请求网络数据
     */
    supportFetchStream: function () {
        if (window.fetch && window.AbortController && window.ReadableStream && window.Request) {
            try {
                new window.ReadableStream({});
                return true;
            }
            catch (e) {
                /* noop */
            }
        }
        return false;
    },
};

export { DIFF_ATTR_RULE_MAP, EMPTY_VALIDATE_RESULT, s$1 as EvtEmitter, HDRCapability as HDR_CAPABILITY, KernelStepKey, KeySystems, LoopMode, ResizeObserver, ResizeObserverPolyfilled, SimpleDefer, StepTimer, TaskLoop, TimeoutDefer, VALIDATE_PASS_RESULT, commonTool, convertCookieStr2Object, cookieTool, costTimeEmitter, destroyProtectDecorator, domTool, encodingTool, getEventEmitterBinder, getEventTargetBinder, getSupportedKeySystemConfig, hashTool, jsonTool, logMethodCallDecoratorCreator, lsTool, mountGlobal, netTool, performanceCostDecoratorCreator, requireModule, runValidators, stepTimerClassDecorator, STEP_TIMER_FG_INST_ID as stepTimerFakeGlobalInstanceId, stringTool, uaMatch, uaTool, urlTool, videoTool };
